var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeaBag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 61v1h3v3h-1v-1h-1v-1h-1v1h-1v-1h-2v1h-2v1h1v1h-2v-1h-2v-3h2v1h2v-1h1v-1zm2-12h-2v-1h-3v-1h1v-1h2v-2h1v1h1zm12 10v2h-2v2h-1v-4zm2 4v-1h1v1h1v1h-6v-1h3zM53 52h3v-1h1v2h-4zm-7-6h2v1h-1v2h-1zm19 1h1v1h-2v-1zm7 15h1v1h-2v-1zm-17 4v-1h2v1h-1zm12-18v1h-1v-1zm2 3v-1h1v1zm1 0h1v1h-1zm-21 1h1v1h-1zm23 0h1v1h-1zm-8 1v1h-1v-1zm-20 4h-1v-1h1zm32 4h1v1h-1zm-20 3h-1v-1h1zm7 1h-1v-1h1zm-21 0h1v1h-1z",
    fill: "#c1c0bc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v-2h1v4h-3v-1h-1v-1h-1v1h-1v1h-3v-1h1v-1h-1v-1h2v-1h2v1h1v-1h1v1h1v1zm12-14v1h1v1h-5v-2zm-19-2v-2h1v1h3v2h-2v-1zm-2 16v1h-1v2h-1v-3zm19-17h-2v-1h2zm0 1v-1h2v1h-1zm-11 0h1v1h-2v-1zm13 1v-1h2v1h-1zm6 3h-2v-1h2zm-2 10h1v1h-2v-1zm-2-13h1v1h-1zm-12 2h-1v-1h1zm13-1h1v1h-1zm-16 1v1h-1v-1zm23 8v1h-1v-1zm-12 5h-1v-1h1zm-7 2h-1v-1h1z",
    fill: "#c0bfbb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 57v1h2v4h1v1h-4v-2h2v-2h-3v-2zm-21 5v-1h3v-1h1v1h1v1h-1v1h-2v-1h-1zm7-18h1v2h-2v1h-1v-2h2zm7 17v2h-3v-1h1v-1zM43 51v-1h1v-1h1v2zm30 11v-2h2v1h-1v1zM50 43h-1v-1h2v1zm-6 15h-1v-1h2v1zm11 7v-1h2v1h-1zm-3-22v1h-1v-1zm11 4h-1v-1h1zm-18 2v-1h1v1zm23 0h-1v-1h1zm0 1v-1h1v1zm3 2v-1h1v1zm-14 0h1v1h-1zm0 1v1h-1v-1zm18 7v-1h1v1zm1 1v-1h1v1zm-24 1h-1v-1h1zm19 1h-1v-1h1z",
    fill: "#c2c1bd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 57h-1v2h-1v-1h-1v-1h1v-1h-2v2h-1v2h-3v-1h-1v-1h1v-1h-1v1h-1v-1h-2v-2h1v1h5v-1h1v-1h1v1h4zm13 1h1v1h-1v1h-1v1h-1v-2h1v-1zm0-10h-1v-2h1v1zm-25 5v2h-1v-2zm-2 3h-1v-2h1v1zm4-12h1v1h-1zm16 2v-1h1v1zm3 0h-1v-1h1zm4 3h1v1h-1zm3 3v-1h1v1zm-22 1v1h-1v-1zm18 5h-1v-1h1zm5 1h-1v-1h1zm2 0v-1h1v1zm-4 0v1h-1v-1zm-2 3h-1v-1h1zm-28 1h1v1h-1z",
    fill: "#c6c5c1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67 52h-1v-1h-4v1h-1v-3h1v-1h2v1h2v1h2v1h1v1h1v1h-3zM50 68v-1h-1v-1h1v-1h1v1h1v1h1v1h-1zm-5-1h-1v-1h2v1h1v1h-2zm10-16v-1h1v-1h1v2zm-2 0h2v1h-2zm-2 2h-1v-1h2v1zm25 9h-2v-1h2zM53 44h-1v-1h1zm-1 6h-1v-1h1zm3-1v1h-1v-1zm-5 2v-1h1v1zm23 11h1v1h-1zm-2 2v-1h1v1zm-6 0v1h-1v-1zm3 1h-1v-1h1zm-13 2v-1h1v1z",
    fill: "#bfbeba"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60v1h-3v-1h2v-2h1v1h1v1zm16-3v-2h2v2zm-15 4v-1h4v1h-1zm8 0v1h-3v-2h1v1zm-6-18h2v1h-1v1h-1zm17 18v-3h1v3zm7 1h-2v-1h1v-1h1zM63 46h2v1h-2zm5 2h-2v-1h2zm0 15v-1h2v1h-1zM48 46h-1v-1h1zm-3 1h1v1h-1zm23 1h1v1h-1zm3 3h-1v-1h1zm-15 3h-1v-1h1zm0 1v-1h1v1zm-13 0h1v1h-1zm1 2v-1h1v1zm21 0v1h-1v-1zm12 2v1h-1v-1zm-21 1h1v1h-1zm12 2h-1v-1h1z",
    fill: "#c3c2be"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h2v1h-1v1h-5v-1h-1v-2h2v1h2v-1zm20-8v1h-1v1h-1v-2zm-1 16v-1h1v-1h1v2zm1-12v-2h1v2zm-26 3h1v1h-2v-1zm29 7h-2v-1h2zM49 41h1v1h-1zm20 2v1h-1v-1zm-23 2h1v1h-1zm21 0v1h-1v-1zm4 4h1v1h-1zm1 1h1v1h-1zm-30 2v-1h1v1zm32 1v-1h1v1zm-26 4h1v1h-1zm7 1v1h-1v-1zm13 1v-1h1v1zm-26 4v-1h1v1z",
    fill: "#c7c6c2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-2v-2h2zm9 1h-1v-1h-1v-2h1v1h1zm-2-7v-1h3v1zm12 0h1v3h-1zm4-10h-1v-2h1v1zm-19 1h-1v-2h1v1zm16 12h2v1h-2zm2 4v-2h1v2zm-1-15v1h-1v-1zm-21 2v1h-1v-1zm24 1h1v1h-1zm4 3h-1v-1h1zm-29 2v1h-1v-1zm0 1h1v1h-1zm1 3v-1h1v1zm2 0v1h-1v-1zm10 1h-1v-1h1zm19-1v1h-1v-1zm-28 2h-1v-1h1zm4 1h-1v-1h1zm3 0v-1h1v1zm16-1h1v1h-1zm-5 2v-1h1v1zm-23 2v1h-1v-1z",
    fill: "#c4c3bf"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102v-3h4v1h4v5h-4v-1h-1v-1h-1v-1z",
    fill: "#eae4e4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M54 57v2h-1v-3h2v1zm18 3v-1h2v-1h1v2zm-16-6v1h-3v-1h1zm-2 5h2v1h-1v1h-1zm13-12h-1v-1h2v1zm-23 5h-1v-1h2v1zm20 2v1h-2v-1h1zm-2-8v-1h1v1zm6 1h1v1h-1zm1 1h1v1h-1zm-26 1h1v1h-1zm29 1v1h-1v-1zm-28 3v1h-1v-1zm7 1v-1h1v1zm-4 4h-1v-1h1zm10 0h-1v-1h1zm-10 1v-1h1v1zm21 0h-1v-1h1zm-19 1h-1v-1h1zm20 1v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#c5c4c0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82 99v4h-1v-1h-3v-1h1v-2zm12 2h3v1h-1v1h-2zm-11-3h-1v-1h4v1zm7 0v1h-4v-1h2zm4 5v1h-4v-1h1zm-10-7h-1v-1h1zm0 8h-1v-1h1z",
    fill: "#e8e4e3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82 97v-1h2v-1h1v1h5v1zm18 4h-3v-1h-3v-1h4v1h2zm0-1v-2h2v1h2v1zm6-1v-1h1v1z",
    fill: "#e6e2e1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96 98h3v1h1v1h-2v-1h-2zm-6-1v1h-4v-1h2zm4 3h3v1h-3zm-15 1h-1v-2h1v1zm-2-1v1h-1v-1zm23 1v-1h1v1zm-3 0h1v1h-1z",
    fill: "#e7e3e2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50v1h-2v1h-1v-2zm-2 18v1h-3v-1h1zm16-4h2v1h-2zm-12 3v1h-2v-1h1zm17-4v1h-1v-1zm-25 4h1v1h-1zm9 1v1h-1v-1zm-14 1h1v1h-1z",
    fill: "#bdbcb8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v-2h4v1h1v1h-1v2h-2v-1h-1v-1z",
    fill: "#e5e4e2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51 70h-3v-2h1v1h2zm-7 0v-1h3v1h-1zm11-1h-1v-1h2v1zm20-6v-1h1v1zm-27 8h-1v-1h1z",
    fill: "#bbbab6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h2v1h-2zm28 10v1h-1v-2h1zm-8-21h-1v-1h1zm-1 1h-1v-1h1zm-14 1v1h-1v-1zm13 4v1h-1v-1zm-13 5h1v1h-1zm-1 2h1v1h-1zm16 3h1v1h-1z",
    fill: "#84807d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1zm-3 1v1h-1v-1zm1 0h1v1h-1zm14 13v1h-1v-1zm-21 4h-1v-1h1zm3-1v1h-1v-1zm1 0h1v1h-1zm4 0h1v1h-1zm3 1v-1h1v1zm-12 0v1h-1v-1z",
    fill: "#bebdb9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68h4v1h-4zm0 3v1h-1v-2h1zm31-9v1h-1v-1zm-2 2v-1h1v1zm-2 1h-1v-1h1zm-19 3h1v1h-1z",
    fill: "#bcbbb7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65v-1h2v1h-1zm-17 5h-1v-1h2v1zm-7 1h-2v-1h2zm4-2h1v1h-1zm6 1h-1v-1h1zm-8 1h-1v-1h1z",
    fill: "#bab9b5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-2h1v2zm19-18v1h-1v-1zm-4 5v-1h1v1zm4-1h1v1h-1zm-10 4v1h-1v-1zm-9 1h1v1h-1zm5 3h-1v-1h1zm-1 6h-1v-1h1z",
    fill: "#8d8986"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86v1h-2v-1h1zm10 0v1h-2v-1h1zm6-15h1v1h-1zm-4 2h1v1h-1zm3 2h-1v-1h1zm-14 8h1v1h-1zm3 3h-1v-1h1z",
    fill: "#81807e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1zm-11 3v-1h1v1zm-1 0h1v1h-1zm11 1h1v1h-1zm-11 5v-1h1v1zm-3 4h-1v-1h1zm-2 1h-1v-1h1zm3 0v1h-1v-1zm21 3v-1h1v1z",
    fill: "#827e7b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58 75v-1h1v2h-1zm9 0v1h-1v-1zm0 5h-1v-1h1zm-15 1v-1h1v1zm15 0h1v1h-1zm-16 6h1v1h-1zm-4 1h1v1h-1zm6 1h-1v-1h1z",
    fill: "#85817e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50 90h-1v-1h-1v-1h2zm0-9v-1h2v1h-1zm6-4v-1h1v1zm14 2h-1v-1h1zm-6 1v-1h1v1zm5 0h-1v-1h1z",
    fill: "#837f7c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-3h1v1zm4 16v2h-1v-2zm-1 3h-2v-1h2zm-1-4h1v1h-1z",
    fill: "#c4c1ba"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M70 54h-1v-1h3v1h-1v1h-1zm-21-4v2h-1v-1h-1v-1zm24 3h1v1h-1z",
    fill: "#bfbebc"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45 72v-1h3v1h-1zm31-9v-1h1v1zm-23 6v1h-1v-1zm-3 2v-1h1v1zm7-1v1h-1v-1zm-13 4h-1v-1h1z",
    fill: "#b8b7b3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M61 63v2h-3v-1h2v-1zm-5-21v1h-1v-1zm-1 2v1h-1v-1zm6 17h-1v-1h1z",
    fill: "#c3c0b9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56v-1h5v1h-1zm-23-5v-1h1v1zm2 0v1h-1v-1z",
    fill: "#c2c1bf"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h3v1h-3zm-1-1h-1v-1h2v1zm-19-3h1v1h-1zm-5 38h-1v-1h1z",
    fill: "#c3c2c0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1zm39 4h-1v-1h1zm7 25h1v1h-1zm16 9h-1v-1h1zm1 0h1v1h-1zm7 3h1v1h-1zm-38 4h1v1h-1z",
    fill: "#aaa",
    fillOpacity: 0.012
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70h-1v-1h1zm-2 5v-1h1v1zm-10 6h-1v-1h1zm0 2v-1h1v1zm-1 2v-1h1v1zm7 5h-1v-1h1zm-9 0h1v1h-1z",
    fill: "#7b7a78"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1zm-9 3h-1v-1h1zm12 0v-1h1v1zm1 2v1h-1v-1zm8 0h1v1h-1zm-11 2h1v1h-1zm10 5h1v1h-1z",
    fill: "#7d7976"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h-1v-1h1zm-2 1h-1v-1h1zm-1 1v1h-1v-1zm7 1v-1h1v1zm-7 2v1h-1v-1zm10 0v1h-1v-1zm-14 7v1h-1v-1z",
    fill: "#86827f"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M61 88v1h-2v-1h1zm-2 1v1h-1v-1zm8 1v-1h1v1zm4 0v1h-1v-1zm-16 3h-1v-1h1zm12 1v1h-1v-1z",
    fill: "#797876"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M94 102h-3v-2h2v1h1zm-1-8h-1v-1h1zm-2 5v1h-1v-1z",
    fill: "#e7e6e4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1zm18 7h1v1h-1zm-32 9h1v1h-1zm1 22v-1h1v1zm50 12h1v1h-1zm3 1h1v1h-1z",
    fill: "#ccc",
    fillOpacity: 0.02
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h1v1h-2v-1zm6-11v1h-1v-1zm-5 14h-1v-1h1zm-3 0h1v1h-1zm0 2h1v1h-1z",
    fill: "#c7c4bf"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h-2v-2h1v1h1zm5-13v1h-1v-1zm-4 11v1h-1v-1zm-2 4h-1v-1h1z",
    fill: "#c8c5c0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h-1v-1h2v1zm3 4v-1h1v1zm-29 4h1v1h-1zm30 4h1v1h-1zm-30 5v-1h1v1z",
    fill: "#c8c7c3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-1h2v1h-1zM54 48h1v1h-1zm8 19h-1v-1h1zm-1 0v1h-1v-1zM43 91v-1h1v1z",
    fill: "#bdb9b6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52h-1v-1h-2v-1h2v-1h1v1zm1 0h1v1h-1z",
    fill: "#c0bfba"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h1v3h-1zm31-8v1h-1v-1zm-30 1v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#cac9c5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h2v2h-2zm-20-3h-1v-1h1zm25 5v-1h1v1z",
    fill: "#c4c3c1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62h1v3h-1zm1-2v1h-1v-2h1zm-4 6h-1v-1h1z",
    fill: "#c2c0bb"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v1h-1v-2h1zm9-2h-1v-1h1zm1 1v-1h1v1zm-5 0v1h-1v-1zm-7 3v-1h1v1z",
    fill: "#b9b8b4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M53 76v-1h1v1zm-1 2v-1h1v1zm-5 0v1h-1v-1zm6 1v1h-1v-1zm-6 9h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#8b8784"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87v2h-1v-2zm15-11h-1v-1h1zm-9 3v1h-1v-1zm-4 6h-1v-1h1zm-10 8h-1v-1h1z",
    fill: "#838280"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M67 76v2h-1v-2zm-3 1v1h-1v-1zm2 2h-1v-1h1zM48 89v1h-1v-1zm19 1h1v1h-1z",
    fill: "#817d7a"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M55 78v-1h1v1zm11 0h-1v-1h1zm-21 5h1v1h-1zm1 4v-1h1v1zm4 1v-1h1v1zm24 7v-1h1v1z",
    fill: "#888481"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M86 100v-1h4v1h-1zm-2 2v1h-2v-1h1z",
    fill: "#e9e4e3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M59 52h-2v-1h2zm-8-11v1h-1v-1zm0 2v-1h1v1zm14 11h-1v-1h1z",
    fill: "#c1c0bb"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1zm-7 4v1h-1v-1zm2 0v1h-1v-1zm9 15h-1v-1h1zm5 0v-1h1v1z",
    fill: "#c1c0bd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54v-1h2v1h-1zm28 3h1v1h-2v-1zm-8-12h1v1h-1z",
    fill: "#c7c6c3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v-1h3v1zm-17-4v-1h1v1zm26 3h1v1h-1z",
    fill: "#c0bfbc"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1zm-8 5v1h-1v-1zm-13 4h1v1h-1zm1 7v-1h1v1zm11 3v1h-1v-1z",
    fill: "#85817d"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1zm1 0h1v1h-1zM48 84v-1h1v1zm2 3v1h-1v-1zm-3 1v1h-1v-1z",
    fill: "#8a8683"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1zm-6 7v-1h1v1zm3 5h-1v-1h1zm-2 1v-1h1v1zm-8 2h1v1h-1z",
    fill: "#82817f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M71 73h-1v-1h1zm4 1h-1v-1h1zM59 88v1h-1v-1zm10 1h-1v-1h1zm1 4v1h-1v-1z",
    fill: "#7c7b79"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M63 74h-1v-1h1zm5 5v-1h1v1zm-14 0h1v1h-1zm19 5v-1h1v1zm-23 2h1v1h-1z",
    fill: "#7b7775"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-1v-1h1zm-15 4v-1h1v1zm12 0v-1h1v1zm4 3h-1v-1h1zm2 0h1v1h-1z",
    fill: "#807c79"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1zm3 1v-1h1v1zm9 2v1h-1v-1zm-1 3h-1v-1h1zm6 9h1v1h-1z",
    fill: "#898582"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79h-1v-1h1zm-18 3h-1v-1h1zm1 3v-1h1v1zm-4 4h1v1h-1zm15 3h1v1h-1z",
    fill: "#7e7a77"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81h-1v-1h1zm18 1v-1h1v1zm-1 3v1h-1v-1zm7 2v1h-1v-1zm-1 4v-1h1v1z",
    fill: "#86827e"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M90 96v-1h3v-1h1v2z",
    fill: "#e4e3e1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97h2v1h-2zm-3 2h2v1h-2zm23-2h1v1h-1z",
    fill: "#e7e3e0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M82 99v-1h4v1h-1zm3 5h-1v-1h1z",
    fill: "#e9e4e4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1zm18 1h-1v-1h1zm13 39v1h-1v-1zm3 3h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1zm-25 4h1v1h-1zm28 0v1h-1v-1zm-29 1h1v1h-1z",
    fill: "#cdccc8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48h-3v-2h1v1h2z",
    fill: "#c3bfbc"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M58 48v-1h1v2h-1zm2 5h1v1h-1zm-3 10h1v1h-1z",
    fill: "#c4c1bc"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1zm-1 6h1v1h-1zm2 21v1h-1v-1zm43 4v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v2h-1v-1zm20 3v1h-1v-1zm3 0h1v1h-1z",
    fill: "#bfbebb"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-2v-1zm-27-2v1h-1v-1zm26 3v1h-1v-1z",
    fill: "#c5c4c2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68h-2v-1h1v-1h1zM44 88v1h-1v-1z",
    fill: "#c1bdba"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1zm-13 6v1h-1v-1zm3 4v-1h1v1zM49 91v-1h1v1z",
    fill: "#817d7b"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1zm4 1v1h-1v-1zm1 3v-1h1v1zM56 89h-1v-1h1z",
    fill: "#848381"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v1h-3v-1zM44 84h-1v-1h1z",
    fill: "#9d9996"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M68 73h1v1h-1zm-2 10v1h-1v-1zm0 3h-1v-1h1zm-18 5v1h-1v-1z",
    fill: "#848280"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74h1v1h-1zm27 7v-1h1v1zm-24 5v-1h1v1zm24 1v-1h1v1z",
    fill: "#86837c"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v1h-1v-1zm27 1v1h-1v-1zm-29 1v1h-1v-1zm24 16h1v1h-1z",
    fill: "#827f7a"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1zm24 11v-1h1v1zm-25 5h-1v-1h1zm23 0v1h-1v-1z",
    fill: "#83807b"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75v1h-1v-1zm-6 3v-1h1v1zm3 1h-1v-1h1zm-2 7h1v1h-1z",
    fill: "#878380"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M52 76h2v1h-2zm-3 1v-1h1v1zm23 6h-1v-1h1z",
    fill: "#85827e"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78h-1v-1h1zm-16 3v-1h1v1zm2 2h-1v-1h1zm-2 1h-1v-1h1z",
    fill: "#908c89"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82h1v1h-1zm-10 2h1v1h-1zm12 0v1h-1v-1zm2 7h-1v-1h1z",
    fill: "#848382"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1zm-2 3h-1v-1h1zm5 1h-1v-1h1zm4 6h1v1h-1z",
    fill: "#807f7d"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M62 83h1v1h-1zm-2 5v-1h1v1zm-2 1h-1v-1h1zm2 1v-1h1v1z",
    fill: "#7a7977"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83h1v1h-1zm6 4v1h-1v-1zm-1 1v1h-1v-1zm-10 1v1h-1v-1z",
    fill: "#7d7c7a"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93h1v1h-1zm0 6h-1v-1h1zm0 0h1v1h-1zm3 2h-1v-1h1z",
    fill: "#e6e5e3"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98v-1h1v1zm-2 1h-1v-1h1zm20 0v-1h1v1zm-22 1h1v1h-1z",
    fill: "#e7e3e1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M105 97v1h-3v-1zm-30 3v-1h1v1z",
    fill: "#e6e2df"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M103 99h-1v-1h4v1z",
    fill: "#e6e2e0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M104 100v1h-2v-1h1zm-27 2v-1h1v1zm18 1v1h-1v-1z",
    fill: "#ede9e8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1zm6 8h1v1h-1zm3 4h-1v-1h1z",
    fill: "#c1c0ba"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M60 63h-1v-2h1v1zm-6-21v-1h1v1z",
    fill: "#c5c2bb"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42v-1h1v1zm5 15h1v1h-1zm-2 5h1v1h-1z",
    fill: "#c7c4bd"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1zm21 1h1v1h-1zm7 14v-1h1v1z",
    fill: "#cbcac6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1zm11 42v-1h1v1zm13 7v-1h1v1z",
    fill: "#c6c6c6",
    fillOpacity: 0.035
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1zm-2 2v-1h1v1zm-2 9h-1v-1h1z",
    fill: "#c6c4c0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1zm3 1h1v1h-1zm0 20h1v1h-1z",
    fill: "#c2bfbb"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45h1v1h-2v-1zm2 21v-1h1v1z",
    fill: "#c3c0ba"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v2h-1v-1zm0 18v1h-1v-1z",
    fill: "#c2bfba"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51h-1v-2h1v1zm23 4h-1v-1h1z",
    fill: "#c0bfbd"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66h-1v-1h2v1zm-8-17v1h-1v-1z",
    fill: "#bfbdb9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-3h1v3z",
    fill: "#bfbeb9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1zm21 3h-1v-1h1zm4 0v-1h1v1z",
    fill: "#c1c0be"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53h-2v-1h2zm25 3h1v1h-1z",
    fill: "#c6c5c3"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h1v2h-1v-1zm0-18h-1v-1h1z",
    fill: "#b2b2b2",
    fillOpacity: 0.039
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v1h-1zm-1 1v1h-1v-1zm4 4h-1v-1h1z",
    fill: "#c4c2bd"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58v-1h2v1h-1zm-3-3h-1v-1h1z",
    fill: "#c4c3c0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55v1h-1v-1zm-4 1v1h-1v-1zm-1 5h1v1h-1z",
    fill: "#c5c3be"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57h-1v-2h1v1zm1 1v-1h1v1z",
    fill: "#c5c4c1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v2h-2v-1z",
    fill: "#c8c7c5"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1zm6 28h-1v-1h1zm1 19v1h-1v-1z",
    fillOpacity: 0.004
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v1h-1v-1zm0 17v1h-1v-1zm0 4h-1v-1h1z",
    fill: "#b4b4aa",
    fillOpacity: 0.094
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1zm3 11v-1h1v1zm-4 13v1h-1v-1z",
    fill: "#7d7b77"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1zm-9 19v1h-1v-1zm10 7v1h-1v-1z",
    fill: "#7d7975"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1zm-1 2h1v1h-1zM58 92v-1h1v1z",
    fill: "#7c7a78"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1zM54 86v1h-1v-1zm15 4v-1h1v1z",
    fill: "#82807d"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71v-1h1v1zm3 0h-1v-1h1zm-10 1h1v1h-1z",
    fill: "#b7b6b2"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M55 71h-1v-1h2v1zm-2-1v1h-1v-1z",
    fill: "#b6b5b1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70v1h-1v-1zM62 89h-1v-1h1zm-6 3h1v1h-1z",
    fill: "#7a7876"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1zM58 81v1h-1v-1zm-8 11v1h-1v-1z",
    fill: "#84827d"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72h-1v-1h1zm-14 8h1v1h-1zm13 1v1h-1v-1z",
    fill: "#807e7a"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74v1h-1v-1zm-11 4h1v1h-1zm0 10h1v1h-1z",
    fill: "#8f8b88"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1zm-13 3v1h-1v-1zm-3 13h-1v-1h1z",
    fill: "#7f7b78"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M69 74h1v3h-1z",
    fill: "#7f7c79"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75h1v1h-1zm-6 5v-1h1v1zm-5 2v1h-1v-1z",
    fill: "#8e8a87"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h-1v-1h1zm-7 9v-1h1v1zm-5 3h-1v-1h1z",
    fill: "#868583"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M61 76v1h-1v-1zm-15 9v1h-1v-1zm30 7h-1v-1h1z",
    fill: "#8b8785"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1zm2 5v1h-1v-1zm-18 4h1v1h-1z",
    fill: "#85817f"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1zm-12 3v1h-1v-1zm-8 11v-1h1v1z",
    fill: "#7c7875"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77h-1v-1h1zM59 87h1v1h-1zm8 2h-1v-1h1z",
    fill: "#767573"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1zM60 89v1h-1v-1zm7 5h-1v-1h1z",
    fill: "#757472"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79h1v1h-1zm7 0v1h-1v-1zm3 6v-1h1v1z",
    fill: "#787471"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M76 80v1h-1v-1zm0 3v1h-1v-1zm-10 7h1v1h-1z",
    fill: "#817e79"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M51 81v1h-1v-1zm-3 1h1v1h-1zm-2 2v-1h1v1z",
    fill: "#8b8884"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M63 82h-1v-1h1zm-6 6v-1h1v1zm9 1h1v1h-1z",
    fill: "#7f7e7c"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M62 83v1h-1v-2h1zm-13 8v1h-1v-1z",
    fill: "#807f7e"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90h1v1h-2v-1zm19-8h1v1h-1z",
    fill: "#827e79"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85h2v1h-2zm-1-1h1v1h-1z",
    fill: "#8c8983"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95v1h-2v-1h1zm-20-9h-1v-1h1z",
    fill: "#807f7c"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h1v1h-1zm9 0h1v1h-1zm-11 5v-1h1v1z",
    fill: "#d7d7d7",
    fillOpacity: 0.051
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h-1v-1h1zm-17 0h1v1h-1zm-5 2h-1v-1h1z",
    fill: "#7e7c79"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M88 95v1h-3v-1h1z",
    fill: "#e5e1e0"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M97 97h2v1h-2zm-6 8h1v1h-1z",
    fill: "#e9e5e1"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99v-1h3v1z",
    fill: "#e8e4e2"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M106 99v1h-1v-1zm-5 2v1h-1v-1zm-21 2v-1h1v1z",
    fill: "#ebe7e6"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M89 105v1h-3v-1h1z",
    fill: "#f1edec"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1zm-15 7v-1h1v1z",
    fill: "#d4d4d4",
    fillOpacity: 0.024
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M62 37h1v1h-1zM41 77v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1zm28 47h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-1v-1zm-13 9v1h-1v-1z",
    fill: "#dadada",
    fillOpacity: 0.027
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v-1h1v1zm8-1v1h-1v-1z",
    fill: "#d2cdc5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40h2v1h-2z",
    fill: "#d7d4cd"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42v-1h1v1zm-1 3v-1h1v1z",
    fill: "#c6c2bc"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M61 42v1h-1v-2h1z",
    fill: "#c5c1b8"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h2v1h-2z",
    fill: "#cac7be"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43h-1v-2h1v1z",
    fill: "#c9c6bd"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1zm-19 2v1h-1v-1z",
    fill: "#cfcec9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1zm1 1h1v1h-1z",
    fill: "#c2bfb8"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1zm1 18h-1v-1h1z",
    fill: "#c6c3bc"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h-1v-1h2v1z",
    fill: "#cac7bf"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-2v-1z",
    fill: "#c9c6c0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1zm-6 14v-1h1v1z",
    fill: "#c8c5bf"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1zm1 3v-1h1v1z",
    fill: "#d0cfcb"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1zm24 2v-1h1v1z",
    fill: "#cecdc9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1zm4 4v-1h1v1z",
    fill: "#c3c0bb"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1zm-3 11h-1v-1h1z",
    fill: "#c9c6c1"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1zm6 13h-1v-1h1z",
    fill: "#c6c5c2"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47h-1v-2h1v1z",
    fill: "#c2bfbc"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1zm-3 7h1v1h-1z",
    fill: "#c4c2bc"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1zm-4 10v-1h1v1z",
    fill: "#c9c8c4"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M55 47v-1h2v1h-1z",
    fill: "#c5c1be"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1zm1 1h1v1h-1z",
    fill: "#c1beb9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47v-1h1v1zm2 0v1h-1v-1z",
    fill: "#c0bdb8"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-2h1z",
    fill: "#c0beba"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48h1v1h-1zM43 88v-1h1v1z",
    fill: "#c0bcb9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1zm2 18v1h-1v-1z",
    fill: "#c2bebb"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52h2v1h-2z",
    fill: "#c4c3be"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1zm-11 1v1h-1v-1z",
    fill: "#c2c1bc"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h1zm3 5v-1h1v1z",
    fill: "#c3c1bc"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55v-1h1v1zm0 5h1v1h-1z",
    fill: "#c6c3be"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M72 55h-1v-1h2v1z",
    fill: "#bebdbb"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1zm0 2h1v1h-1z",
    fill: "#c7c4c0"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M77 57h-1v-2h1v1z",
    fill: "#cdccca"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-2h1v1z",
    fill: "#c6c3bf"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1zm-3 2v1h-1v-1z",
    fill: "#c3c1bb"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1zM42 87v1h-1v-1z",
    fill: "#b9b9b9",
    fillOpacity: 0.043
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65v1h-1v-1zm-5 3h-1v-1h1z",
    fill: "#c0bdba"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67v-1h1v1zm-6 1h1v1h-1z",
    fill: "#bbb8b3"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h-1v-1h1zm-2 0h1v1h-1z",
    fill: "#bab6b3"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1zm-6 3v-1h1v1z",
    fill: "#b8b5b0"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67v1h-1v-1zM59 78h-1v-1h1z",
    fill: "#918d84"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h1v1h-1zM43 87v-1h1v1z",
    fill: "#ada9a6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M74 69v-1h1v1zm0 4v-1h1v1z",
    fill: "#7b7978"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69v1h-1v-1zM55 89v1h-1v-1z",
    fill: "#7b7975"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1zm-7 26v-1h1v1z",
    fill: "#777673"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71v-1h1v1zm5 22v1h-1v-1z",
    fill: "#807f7a"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M69 71v-1h1v1zm-24 6v1h-1v-1z",
    fill: "#8a8984"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1zm4 15h1v1h-1z",
    fill: "#81807c"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1zM61 92v1h-1v-1z",
    fill: "#7a7975"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70h1v1h-1zM66 84v-1h1v1z",
    fill: "#7d7a75"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#b6b4b0"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71h1v1h-1zm-8 3v1h-1v-1z",
    fill: "#918d8a"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1zM44 82v-1h1v1z",
    fill: "#8e8c89"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v1zm-4 8h-1v-1h1z",
    fill: "#888785"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M76 71h1v1h-1zM51 92h-1v-1h1z",
    fill: "#797671"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73h-1v-1h1zm-8 17h1v1h-1z",
    fill: "#a29f9a"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73h-1v-1h1zM45 91h1v1h-1z",
    fill: "#9a9792"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M59 72h1v1h-1zm-11 2h1v1h-1z",
    fill: "#96938e"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1zM44 87v-1h1v1z",
    fill: "#94908d"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1zm-15 8h-1v-1h1z",
    fill: "#8a8684"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1zm-4 10h-1v-1h1z",
    fill: "#868684"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M60 74h-1v-1h1zm-11 4h-1v-1h1z",
    fill: "#8c8984"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74h-1v-1h1zm-3 2h1v1h-1z",
    fill: "#8c8985"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1zM53 88v-1h1v1z",
    fill: "#868481"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-1v-1h1zm-2 11h-1v-1h1z",
    fill: "#8a8885"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1zM54 85h1v1h-1z",
    fill: "#888582"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1zm-2 23v-1h1v1z",
    fill: "#807c77"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75v-1h1v1zm22 8h1v1h-1z",
    fill: "#88857f"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M57 74h1v1h-1zM45 85v1h-1v-1z",
    fill: "#928e8b"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75v-1h1v1zm-7 9h1v1h-1z",
    fill: "#837f7e"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M72 74v1h-1v-1zm2 1v-1h1v1z",
    fill: "#7c7c7a"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M47 76h-1v-1h1zm6 8h1v1h-1z",
    fill: "#918e87"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1zm-4 15v1h-1v-1z",
    fill: "#87847f"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1zm12 2h-1v-1h1z",
    fill: "#86837e"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h-1v-1h1zm-6 4h-1v-1h1z",
    fill: "#878381"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1zm3 0v1h-1v-1z",
    fill: "#8f8c87"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M73 76h-1v-1h1zM60 87v-1h1v1z",
    fill: "#7e7d7b"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76h1v1h-1zm-5 6h1v1h-1z",
    fill: "#888480"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M63 77h-1v-1h1zm11 6v-1h1v1z",
    fill: "#86837b"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h1v1h-1zm-11 6v1h-1v-1z",
    fill: "#898886"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77h-1v-1h1zm-8 10v1h-1v-1z",
    fill: "#777675"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77v-1h1v1zM61 89h1v1h-1z",
    fill: "#7d7c79"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1zm11 5v-1h1v1z",
    fill: "#85827d"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78h-1v-1h1zm7 0v-1h1v1z",
    fill: "#85827f"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h1v1h-1zm-3 16h-1v-1h1z",
    fill: "#7c7774"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h1v1h-1zm-6 6v-1h1v1z",
    fill: "#878684"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h1v1h-1zM55 87v-1h1v1z",
    fill: "#848380"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77v1h-1v-1zm-7 16v-1h1v1z",
    fill: "#7b7977"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M76 77v1h-1v-1zM49 90v1h-1v-1z",
    fill: "#787775"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1zm23 2h-1v-1h1z",
    fill: "#8b8683"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78v1h-1v-1zm9 4v-1h1v1z",
    fill: "#8c8884"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79v-1h1v1zm0 7h-1v-1h1z",
    fill: "#8c8b89"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79v-1h1v1zm-5 3h1v1h-1z",
    fill: "#7e7a78"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v-2h1v2z",
    fill: "#757170"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M52 80h-1v-1h1zm-4 2h-1v-1h1z",
    fill: "#8a8685"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80v-1h1v1zm-15 1h1v1h-1z",
    fill: "#888581"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79v1h-1v-1zm-5 13v1h-1v-1z",
    fill: "#7a7877"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M76 79h1v1h-1zm-13 8v-1h1v1z",
    fill: "#827f79"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81h-1v-1h1zm8 3v-1h1v1z",
    fill: "#7f7b7a"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81v-1h1v1zm27 7v-1h1v1z",
    fill: "#827d7b"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h1v1h-1zm1 4h1v1h-1z",
    fill: "#7d7978"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h1v1h-1zm0 7v1h-1v-1z",
    fill: "#7f7c77"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81h-1v-1h1zm29 18v1h-1v-1z",
    fill: "#c4c4c4",
    fillOpacity: 0.051
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82v-1h1v1zm20 10h1v1h-1z",
    fill: "#837f7f"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h1zm17 7h-1v-1h1z",
    fill: "#87837f"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M59 82v-1h1v1zm-6 2v-1h1v1z",
    fill: "#85817c"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83v-1h1v1zm5 6h-1v-1h1z",
    fill: "#858480"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M55 82h1v1h-1zm0 3h1v1h-1z",
    fill: "#84807f"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M69 82v1h-1v-1zm0 1h1v1h-1z",
    fill: "#8a877e"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83h-1v-1h1zm-1 3v1h-1v-1z",
    fill: "#aaa",
    fillOpacity: 0.035
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82v1h-1v-1zm4 6v1h-1v-1z",
    fill: "#bcbcb3",
    fillOpacity: 0.106
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83h1v1h-1zm13 4h-1v-1h1z",
    fill: "#898684"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M72 84v-1h1v1zm-15 1v1h-1v-1z",
    fill: "#827e7d"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1zm-1 11h1v1h-1z",
    fill: "#86827d"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M43 85v-1h1v2h-1z",
    fill: "#979390"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M47 85h-1v-1h1zm18 6v1h-1v-1z",
    fill: "#8a8782"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M58 84v1h-1v-1zm-8 1v1h-1v-1z",
    fill: "#7d7a79"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84v1h-1v-1zm-2 21h1v1h-1z",
    fill: "#c6c6c6",
    fillOpacity: 0.071
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v1h-1v-1zm5 3h1v1h-1z",
    fill: "#86817f"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M65 87v-1h1v1zm5 5h-1v-1h1z",
    fill: "#817e7d"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M68 87v-1h1v1zm-3 2v1h-1v-1z",
    fill: "#81807d"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M70 86v1h-1v-1zm0 6h1v1h-1z",
    fill: "#807f7b"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87h-1v-1h1zm0 1v-1h1v1z",
    fill: "#837f7b"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M102 86v1h-1v-1zm-10 3v-1h1v1z",
    fill: "#cecece",
    fillOpacity: 0.082
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M62 88v-1h1v1zm8 1v-1h1v1z",
    fill: "#827e7a"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h1v1h-1zm-11 2h1v1h-1z",
    fill: "#828180"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87h1v1h-1zm-5 4v1h-1v-1z",
    fill: "#84807a"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M72 87h1v1h-1zm-7 4v-1h1v1z",
    fill: "#86837d"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M87 88v1h-1v-1zm4 1v1h-1v-1z",
    fill: "#bdbdb7",
    fillOpacity: 0.153
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M89 89h-1v-1h1zm-47 2h-1v-1h1z",
    fill: "#bbb9b6",
    fillOpacity: 0.373
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M105 89h-1v-1h1zm-13 3h-1v-1h1z",
    fill: "#d4d4d4",
    fillOpacity: 0.047
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M55 90v-1h1v1zm13 6h-1v-1h1z",
    fill: "#767572"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M72 90v-1h1v1zm3 1v1h-1v-1z",
    fill: "#858180"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M78 89h1v2h-1v-1z",
    fill: "#94918a",
    fillOpacity: 0.282
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M75 90h1v1h-1zm1 5h1v1h-1z",
    fill: "#96928b"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1zm0 2v1h-1v-1z",
    fill: "#797875"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91v1h-1v-1zm9 3h1v1h-1z",
    fill: "#7a7976"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h1v1h-1zm11 4h-1v-1h1z",
    fill: "#7d7c78"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92v-1h1v1zm8-1v1h-1v-1z",
    fill: "#737370"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M94 91v1h-1v-1zm-7 1h1v1h-1z",
    fill: "#bfbfbf",
    fillOpacity: 0.031
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M106 92h1v1h-1zm-2 2v-1h1v1z",
    fill: "#7f7f7f",
    fillOpacity: 0.008
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94h-1v-1h1zm8 0h-1v-1h1z",
    fill: "#71706e"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M75 95v-2h1v2z",
    fill: "#938f8a"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M95 93v1h-1v-1zm12 5h-1v-1h1z",
    fill: "#ebe8e6"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M91 94h1v1h-2v-1z",
    fill: "#e2e1df"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M92 95v-1h1v1zm3 1v-1h1v1z",
    fill: "#e3e2e0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M96 95v-1h1v1zm0 2v-1h1v1z",
    fill: "#e4e1dd"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95v1h-1v-1zm18 5h1v1h-1z",
    fill: "#e9e5e4"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M90 96h-2v-1h2z",
    fill: "#e6e1e1"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M102 95v1h-1v-1zm-3 2v-1h1v1z",
    fill: "#e6e3de"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M102 96h1v1h-1zm-1 1h1v1h-1z",
    fill: "#e7e4e0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v1h-1v-1zm-5 3v-1h1v1z",
    fill: "#e9e5e2"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M100 98v-1h1v1zm-23 0h1v1h-1z",
    fill: "#e7e3df"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M105 98v-1h1v1zm-28 0v1h-1v-1z",
    fill: "#e9e4e1"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M96 99h-2v-1h2z",
    fill: "#e6e3e1"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M108 98v1h-1v-1zm-17 4h-1v-1h1z",
    fill: "#e9e6e5"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M74 101v-1h1v1zm19 3h1v1h-1z",
    fill: "#eeeae8"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102h-1v-1h1zm22 0v-1h1v1z",
    fill: "#eeeae9"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102h1v1h-2v-1z",
    fill: "#e8e5e3"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105h-1v-1h1zm5 0v1h-1v-1z",
    fill: "#f0eceb"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M91 105h-1v-1h2v1z",
    fill: "#e9e5e3"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1z",
    fill: "#d6d6cc",
    fillOpacity: 0.098
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#e1e1d2",
    fillOpacity: 0.067
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v1z",
    fill: "#bfbfff",
    fillOpacity: 0.016
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#ffbfff",
    fillOpacity: 0.016
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M57 38v1h-1v-1z",
    fill: "#d0d0d0",
    fillOpacity: 0.043
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M58 39h-1v-1h1z",
    fill: "#dadad3",
    fillOpacity: 0.137
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38v1h-1v-1z",
    fill: "#d0cbc3",
    fillOpacity: 0.388
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1z",
    fill: "#d6d3cc",
    fillOpacity: 0.549
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1z",
    fill: "#d0d0c8",
    fillOpacity: 0.533
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38v1h-1v-1z",
    fill: "#cfcfca",
    fillOpacity: 0.51
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h1v1h-1z",
    fill: "#cfcfcb",
    fillOpacity: 0.486
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#d4d1cc",
    fillOpacity: 0.373
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1z",
    fill: "#d7d7cf",
    fillOpacity: 0.125
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h-1v-1h1z",
    fill: "#bfbfbf",
    fillOpacity: 0.016
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1z",
    fill: "#d2d2ce",
    fillOpacity: 0.475
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39v1h-1v-1z",
    fill: "#dfdeda",
    fillOpacity: 0.792
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1z",
    fill: "#e1dcd9",
    fillOpacity: 0.808
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#e1dcd9",
    fillOpacity: 0.804
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#ddd9d5",
    fillOpacity: 0.804
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1z",
    fill: "#dad6d1",
    fillOpacity: 0.812
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40h-1v-1h1z",
    fill: "#d7d3cd",
    fillOpacity: 0.827
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40v-1h1v1z",
    fill: "#d4d1ca",
    fillOpacity: 0.855
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#d9d4c9",
    fillOpacity: 0.941
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M59 39v1h-1v-1z",
    fill: "#cdc8bc"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1z",
    fill: "#d6d2c8",
    fillOpacity: 0.733
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1z",
    fill: "#dcd9cf",
    fillOpacity: 0.608
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#d9d7ce",
    fillOpacity: 0.553
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1z",
    fill: "#d8d7cf",
    fillOpacity: 0.525
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M63 39h1v1h-1z",
    fill: "#dad6d0",
    fillOpacity: 0.624
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v1h-1v-1z",
    fill: "#dbd9d2",
    fillOpacity: 0.824
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#dfdfd8",
    fillOpacity: 0.443
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#edd",
    fillOpacity: 0.059
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1z",
    fill: "#cbcbc6",
    fillOpacity: 0.463
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h1v1h-1z",
    fill: "#d1d0cb"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41v-1h1v1z",
    fill: "#cecdc7"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1z",
    fill: "#d1cdc6"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1z",
    fill: "#d0ccc4"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1z",
    fill: "#cecbc3"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1z",
    fill: "#ceccc2"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h-1v-1h1z",
    fill: "#cfccc2"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M58 40v1h-1v-1z",
    fill: "#c7c3b4"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M59 41h-1v-1h1z",
    fill: "#c7c1b4"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1z",
    fill: "#d5d0c9"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#d5d2ca"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1z",
    fill: "#dad7d0"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#dddbd4"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#d8d8d1",
    fillOpacity: 0.863
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#dcdbd7",
    fillOpacity: 0.788
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#d2d0ce",
    fillOpacity: 0.49
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1z",
    fill: "#c8c8c5",
    fillOpacity: 0.259
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#cccac6",
    fillOpacity: 0.961
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1z",
    fill: "#c1c0b7"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-1v-1h1z",
    fill: "#c2c0b8"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1z",
    fill: "#c9c6be"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h1v1h-1z",
    fill: "#bfbaaa"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1z",
    fill: "#c1bcb1"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1z",
    fill: "#c7c4bb"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#c9c7be"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#cbcbc4"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#cecdc9",
    fillOpacity: 0.988
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1z",
    fill: "#cdcdc9",
    fillOpacity: 0.263
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M46 43v-1h1v1z",
    fill: "#cacaca",
    fillOpacity: 0.114
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42v1h-1v-1z",
    fill: "#cbcac6",
    fillOpacity: 0.855
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h-1v-1h1z",
    fill: "#bfbfb9"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43v-1h1v1z",
    fill: "#c1bfb8"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1z",
    fill: "#bcb7a9"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43v-1h1v1z",
    fill: "#c1bcb3"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1z",
    fill: "#c8c4bc"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1z",
    fill: "#c6c5bd"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#c5c4be"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1z",
    fill: "#cac9c6",
    fillOpacity: 0.765
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1z",
    fill: "#cac9c6",
    fillOpacity: 0.69
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#c0beb8"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#c1beb7"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44h-1v-1h1z",
    fill: "#beb9ad"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43h1v1h-1z",
    fill: "#c4c0b8"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1z",
    fill: "#c5c3bc"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#c5c3b9"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#c9c5bf"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43v1h-1v-1z",
    fill: "#c5c4bf"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43h1v1h-1z",
    fill: "#cccac8",
    fillOpacity: 0.455
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44v1h-1v-1z",
    fill: "#cdcbc7",
    fillOpacity: 0.482
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1z",
    fill: "#c3bfb9"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#c3bfb5"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1z",
    fill: "#c5c5bd"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#c9c7bd"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1z",
    fill: "#cac6c1"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#c8c5c1"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M71 44v1h-1v-1z",
    fill: "#cbcac7",
    fillOpacity: 0.933
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M72 44v1h-1v-1z",
    fill: "#d0caca",
    fillOpacity: 0.173
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45h1v1h-1z",
    fill: "#ccccc9",
    fillOpacity: 0.278
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1z",
    fill: "#cac9c5",
    fillOpacity: 0.969
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45v1h-1v-1z",
    fill: "#c4c0bc"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1z",
    fill: "#c4c0bd"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1z",
    fill: "#c2c0ba"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h1v1h-1z",
    fill: "#c6c4bf"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v1h-1v-1z",
    fill: "#cccac6",
    fillOpacity: 0.71
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1z",
    fill: "#d1d1d1",
    fillOpacity: 0.11
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47v-1h1v1z",
    fill: "#cbcac5",
    fillOpacity: 0.859
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#bab6b1"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#c2c0bc"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#c8c7c2"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#cdcac8",
    fillOpacity: 0.384
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#cbc9c5",
    fillOpacity: 0.694
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1z",
    fill: "#c3c0bc"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47v1h-1v-1z",
    fill: "#c3bfbb"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47h1v1h-1z",
    fill: "#ceccc8",
    fillOpacity: 0.878
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#cfcfc6",
    fillOpacity: 0.106
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#ccccc6",
    fillOpacity: 0.51
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#c4c1bd"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#d1d0cc"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#cbcbc6",
    fillOpacity: 0.604
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M42 49v1h-1v-1z",
    fill: "#ccccc8",
    fillOpacity: 0.255
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50v-1h1v1z",
    fill: "#c9c8c4",
    fillOpacity: 0.973
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49h1v1h-1z",
    fill: "#c1bfbb"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#cdccc7",
    fillOpacity: 0.98
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1z",
    fill: "#ccccc8",
    fillOpacity: 0.275
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#c5c4bf",
    fillOpacity: 0.698
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#cfceca"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#cdccc7",
    fillOpacity: 0.808
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51v-1h1v1z",
    fill: "#c8c8c8",
    fillOpacity: 0.055
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1z",
    fill: "#d0b9b9",
    fillOpacity: 0.043
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#c1bfbc",
    fillOpacity: 0.855
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1z",
    fill: "#d2d1cd"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M76 52h-1v-1h1z",
    fill: "#cfcdc9",
    fillOpacity: 0.502
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h-1v-1h1z",
    fill: "#bfafaf",
    fillOpacity: 0.063
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1z",
    fill: "#c3c2bd",
    fillOpacity: 0.871
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53v-1h1v1z",
    fill: "#cccbc7",
    fillOpacity: 0.953
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#ccccc8",
    fillOpacity: 0.22
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h1v1h-1z",
    fill: "#c3c1bd",
    fillOpacity: 0.835
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1z",
    fill: "#c1c1bd"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v1h-1v-1z",
    fill: "#cac9c7"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1z",
    fill: "#c8c8c6",
    fillOpacity: 0.796
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M78 53v1h-1v-1z",
    fill: "#ccc",
    fillOpacity: 0.078
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#c0bfbb",
    fillOpacity: 0.804
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1z",
    fill: "#cecdcb"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1z",
    fill: "#c9c7c4",
    fillOpacity: 0.447
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v1h-1z",
    fill: "#bfbfba",
    fillOpacity: 0.784
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55v1h-1v-1z",
    fill: "#c7c6c4"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#c0bfbd",
    fillOpacity: 0.627
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1z",
    fill: "#c2c1be",
    fillOpacity: 0.765
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57v-1h1v1z",
    fill: "#c4c2be"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#c7c6c5"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#bfbdbc",
    fillOpacity: 0.675
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1z",
    fill: "#c3c2bd",
    fillOpacity: 0.722
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58h-1v-1h1z",
    fill: "#c5c3bf"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57v1h-1v-1z",
    fill: "#c8c7c4"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1z",
    fill: "#bebcb9",
    fillOpacity: 0.718
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1z",
    fill: "#c0bfba",
    fillOpacity: 0.675
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59v-1h1v1z",
    fill: "#c8c5bd"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M61 58v1h-1v-1z",
    fill: "#c6c3bb"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#bbb9b5",
    fillOpacity: 0.765
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#c2c1bc",
    fillOpacity: 0.631
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1z",
    fill: "#c3c3bf"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v1h-1v-1z",
    fill: "#c4c0b9"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1z",
    fill: "#b8b7b3",
    fillOpacity: 0.792
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#c0c0bc",
    fillOpacity: 0.573
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M43 61h-1v-1h1z",
    fill: "#c9c8c3"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#b9b7b4",
    fillOpacity: 0.816
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#aaa",
    fillOpacity: 0.024
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v1h-1v-1z",
    fill: "#c1bfbb",
    fillOpacity: 0.518
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1z",
    fill: "#c7c4be"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v-1h1v1z",
    fill: "#b9b8b3",
    fillOpacity: 0.847
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62h1v1h-1z",
    fill: "#c1bfbb",
    fillOpacity: 0.471
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-1h1z",
    fill: "#c5c3bd"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#b5b4b0",
    fillOpacity: 0.875
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62h1v1h-1z",
    fill: "#b4a5a5",
    fillOpacity: 0.067
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M41 63h1v1h-1z",
    fill: "#bebeb9",
    fillOpacity: 0.404
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1z",
    fill: "#bbb9b6"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M76 64h-1v-1h1z",
    fill: "#b4b1af"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63h1v1h-1z",
    fill: "#adaaa8"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63v1h-1v-1z",
    fill: "#b4b0ae",
    fillOpacity: 0.91
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M41 65v-1h1v1z",
    fill: "#bfbdba",
    fillOpacity: 0.349
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h1v1z",
    fill: "#bdbdb9"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65h-1v-1h1z",
    fill: "#b7b6b1"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65h-1v-1h1z",
    fill: "#aca9a5"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65v-1h1v1z",
    fill: "#a8a5a1"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M77 65h-1v-1h1z",
    fill: "#b1ada9"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M77 64h1v1h-1z",
    fill: "#b2adaa",
    fillOpacity: 0.925
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M79 64v1h-1v-1z",
    fill: "#b8afb8",
    fillOpacity: 0.114
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#c0bcb9",
    fillOpacity: 0.302
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v1h-1v-1z",
    fill: "#c3bfba"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#c1beba"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1z",
    fill: "#bebbb8"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1z",
    fill: "#bcbab6"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1z",
    fill: "#bdbbb6"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1z",
    fill: "#bbb9b4"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M70 65v1h-1v-1z",
    fill: "#b9b8b3"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66h-1v-1h1z",
    fill: "#b4b4b0"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h1v1h-1z",
    fill: "#b1b0ac"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M72 65h1v1h-1z",
    fill: "#a9a7a3"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65v1h-1v-1z",
    fill: "#a2a099"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66h-1v-1h1z",
    fill: "#938f85"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66v-1h1v1z",
    fill: "#7f7c74"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h-1v-1h1z",
    fill: "#98948e"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#8e8b85",
    fillOpacity: 0.953
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66v-1h1v1z",
    fill: "#aaaaa3",
    fillOpacity: 0.153
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66v1h-1v-1z",
    fill: "#bebeba",
    fillOpacity: 0.247
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67v-1h1v1z",
    fill: "#bebdb9",
    fillOpacity: 0.996
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1z",
    fill: "#c0bcba"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M62 66h1v1h-1z",
    fill: "#bebab7"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h-1v-1h1z",
    fill: "#bcb8b5"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1z",
    fill: "#b9b6b1"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v-1h1v1z",
    fill: "#b8b5af"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M69 66h1v1h-1z",
    fill: "#b3afa9"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67h-1v-1h1z",
    fill: "#a8a49f"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67v-1h1v1z",
    fill: "#96938d"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v1h-1v-1z",
    fill: "#8f8b86"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#939189"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#9a988e"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#89867e"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#87837b"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h1v1h-1z",
    fill: "#757369",
    fillOpacity: 0.988
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v-1h1v1z",
    fill: "#aeaea5",
    fillOpacity: 0.212
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M41 67h1v1h-1z",
    fill: "#bbbbb6",
    fillOpacity: 0.208
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67v1h-1v-1z",
    fill: "#bebdb9",
    fillOpacity: 0.984
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67h1v1h-1z",
    fill: "#b8b4b1"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1z",
    fill: "#bbb7b4"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-1h1v1z",
    fill: "#b9b5b2"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68v-1h1v1z",
    fill: "#b8b5b1"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1z",
    fill: "#b5b2ac"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67h1v1h-1z",
    fill: "#aba8a1"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M69 68v-1h1v1z",
    fill: "#a19c93"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68h-1v-1h1z",
    fill: "#a29991"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M75 68v-1h1v1z",
    fill: "#77736f"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M77 67v1h-1v-1z",
    fill: "#7e7c73"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v1h-1v-1z",
    fill: "#8e8d80"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67h1v1h-1z",
    fill: "#b6b6ae",
    fillOpacity: 0.373
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#b9b9b3",
    fillOpacity: 0.173
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1z",
    fill: "#bbbab6",
    fillOpacity: 0.965
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1z",
    fill: "#bebcb8"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h1v1h-1z",
    fill: "#bebbb7"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v-1h1v1z",
    fill: "#bebbb6"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68v1h-1v-1z",
    fill: "#b9b5b1"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v1h-1v-1z",
    fill: "#b5b1ae"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69h-1v-1h1z",
    fill: "#aca9a4"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v-1h1v1z",
    fill: "#a19e97"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-1h1z",
    fill: "#a29f98"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69v-1h1v1z",
    fill: "#99968d"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69v-1h1v1z",
    fill: "#928e85"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68v1h-1v-1z",
    fill: "#938e86"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1z",
    fill: "#8f8b84"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1z",
    fill: "#827f7d"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1z",
    fill: "#7c7b73"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v1h-1v-1z",
    fill: "#848478"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M79 69h-1v-1h1z",
    fill: "#aeaea5",
    fillOpacity: 0.545
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#b8b8b8",
    fillOpacity: 0.141
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69v1h-1v-1z",
    fill: "#bab9b4",
    fillOpacity: 0.945
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v1h-1v-1z",
    fill: "#bbbab7"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69v1h-1v-1z",
    fill: "#bcb9b5"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v1h-1v-1z",
    fill: "#bcb9b4"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1z",
    fill: "#bbb8b2"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70h-1v-1h1z",
    fill: "#b6b3af"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69v1h-1v-1z",
    fill: "#b1adaa"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h1v1h-1z",
    fill: "#a4a09d"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M64 69h1v1h-1z",
    fill: "#999592"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v1h-1v-1z",
    fill: "#999691"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M67 69v1h-1v-1z",
    fill: "#929088"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M67 70v-1h1v1z",
    fill: "#86857d"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-1v-1h1z",
    fill: "#838178"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69h1v1h-1z",
    fill: "#8e8d86"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h-1v-1h1z",
    fill: "#85847f"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1z",
    fill: "#7e7b77"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v-1h1v1z",
    fill: "#7f7e78"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h1v1h-1z",
    fill: "#727168",
    fillOpacity: 0.984
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1z",
    fill: "#a7a69d",
    fillOpacity: 0.584
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71h-1v-1h1z",
    fill: "#b7b7b7",
    fillOpacity: 0.098
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M42 70h1v1h-1z",
    fill: "#babab5",
    fillOpacity: 0.914
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h-1v-1h1z",
    fill: "#b8b5b3"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70h1v1h-1z",
    fill: "#b8b4b0"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70h1v1h-1z",
    fill: "#b6b3ae"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v-1h1v1z",
    fill: "#b2aeab"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1h-1v-1z",
    fill: "#a9a5a3"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1z",
    fill: "#989490"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1z",
    fill: "#96928f"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71h-1v-1h1z",
    fill: "#94918d"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71h-1v-1h1z",
    fill: "#8c8b86"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-1v-1z",
    fill: "#83827d"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h1v1h-1z",
    fill: "#7c7b77"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70h1v1h-1z",
    fill: "#7a7979"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v1h-1v-1z",
    fill: "#74736f"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M78 70v1h-1v-1z",
    fill: "#67645d",
    fillOpacity: 0.906
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70v1h-1v-1z",
    fill: "#a39f98",
    fillOpacity: 0.427
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M79 71v-1h1v1z",
    fill: "#afaf9f",
    fillOpacity: 0.063
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71v1h-1v-1z",
    fill: "#bbb",
    fillOpacity: 0.059
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M42 72v-1h1v1z",
    fill: "#b4b3af",
    fillOpacity: 0.871
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h1v1h-1z",
    fill: "#b6b5b0"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71h1v1h-1z",
    fill: "#b8b6b2"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71v1h-1v-1z",
    fill: "#b3b1ad"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71h1v1h-1z",
    fill: "#b1afac"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v-1h1v1z",
    fill: "#acaaa7"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h-1v-1h1z",
    fill: "#b0aeaa"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M57 72h-1v-1h1z",
    fill: "#b1afab"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1z",
    fill: "#b2afac"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h1v1h-1z",
    fill: "#afaca8"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v1h-1v-1z",
    fill: "#adaaa5"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72v-1h1v1z",
    fill: "#a29f9b"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#8f8b89"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72h-1v-1h1z",
    fill: "#888784"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72h-1v-1h1z",
    fill: "#858481"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72h-1v-1h1z",
    fill: "#7b7a75"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72v-1h1v1z",
    fill: "#8a8985"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M77 71h1v1h-1z",
    fill: "#656259",
    fillOpacity: 0.89
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M78 72v-1h1v1z",
    fill: "#a2a096",
    fillOpacity: 0.4
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v-1h1v1z",
    fill: "#aea7a1",
    fillOpacity: 0.161
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73h-1v-1h1z",
    fill: "#acaba8",
    fillOpacity: 0.839
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73v-1h1v1z",
    fill: "#b6b5b2"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-1v-1z",
    fill: "#b4b3af"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v-1h1v1z",
    fill: "#b3b2ad"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72v1h-1v-1z",
    fill: "#b0b0a9"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72v1h-1v-1z",
    fill: "#b0aea8"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73h-1v-1h1z",
    fill: "#b2afaa"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1z",
    fill: "#aba8a3"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1z",
    fill: "#a29e9b"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72v1h-1v-1z",
    fill: "#a19d9a"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72h1v1h-1z",
    fill: "#a7a3a0"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h1v1h-1z",
    fill: "#a8a4a1"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v-1h1v1z",
    fill: "#a09c9a"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#817d79"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1z",
    fill: "#858380"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72v1h-1v-1z",
    fill: "#848482"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#858483"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#8e8b87"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#8b8682"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#797570"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v1h-1v-1z",
    fill: "#7d7b7b"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M77 72v1h-1v-1z",
    fill: "#7b7772"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M77 73v-1h1v1z",
    fill: "#666459",
    fillOpacity: 0.894
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v1h-1v-1z",
    fill: "#a8a59a",
    fillOpacity: 0.369
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M79 73v-1h1v1z",
    fill: "#aaaa9f",
    fillOpacity: 0.188
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h-1v-1h1z",
    fill: "#b7b5b2",
    fillOpacity: 0.835
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74v-1h1v1z",
    fill: "#b2b1ad"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1z",
    fill: "#b2b0ab"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v1h-1v-1z",
    fill: "#afaea9"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1z",
    fill: "#aaa9a2"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73v1h-1v-1z",
    fill: "#a1a098"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h1v1z",
    fill: "#999790"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1z",
    fill: "#a09d98"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1z",
    fill: "#98958f"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h-1v-1h1z",
    fill: "#94918b"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M54 73v1h-1v-1z",
    fill: "#989591"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1z",
    fill: "#95918f"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M59 74h-1v-1h1z",
    fill: "#918d89"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v1h-1v-1z",
    fill: "#807c7a"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M67 74h-1v-1h1z",
    fill: "#8b8987"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1z",
    fill: "#82807e"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#888380"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74v-1h1v1z",
    fill: "#787470"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h1v1h-1z",
    fill: "#827f7f"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#6e6b61",
    fillOpacity: 0.886
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74v-1h1v1z",
    fill: "#a7a49b",
    fillOpacity: 0.322
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M80 73v1h-1v-1z",
    fill: "#a8a399",
    fillOpacity: 0.208
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M42 74v1h-1v-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.027
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74v1h-1v-1z",
    fill: "#b3b2ae",
    fillOpacity: 0.82
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#b5b4b0"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75h-1v-1h1z",
    fill: "#adaca7"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1z",
    fill: "#a19e96"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v1h-1z",
    fill: "#9c9992"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74v1h-1v-1z",
    fill: "#a09d96"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v-1h1v1z",
    fill: "#8f8c85"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h-1v-1h1z",
    fill: "#838079"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1z",
    fill: "#94908c"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M57 75h-1v-1h1z",
    fill: "#95918e"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#898683"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h1z",
    fill: "#868281"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1z",
    fill: "#908c88"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M75 75v-1h1v1z",
    fill: "#817e7c"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v1h-1v-1z",
    fill: "#857e7b"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h1v1h-1z",
    fill: "#6d6560",
    fillOpacity: 0.894
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74h1v1h-1z",
    fill: "#a89f9b",
    fillOpacity: 0.231
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75v-1h1v1z",
    fill: "#ababa0",
    fillOpacity: 0.169
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M43 76h-1v-1h1z",
    fill: "#b1afab",
    fillOpacity: 0.804
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75h1v1h-1z",
    fill: "#aeada9"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75v1h-1v-1z",
    fill: "#9b9a95"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M46 76h-1v-1h1z",
    fill: "#95928b"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M48 75v1h-1v-1z",
    fill: "#918e88"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76h-1v-1h1z",
    fill: "#888580"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h1v1h-1z",
    fill: "#8c8887"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1z",
    fill: "#939089"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#8b8885"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1z",
    fill: "#7d7875"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v1h-1v-1z",
    fill: "#7f7f7d"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M74 76v-1h1v1z",
    fill: "#7b7b79"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M75 76v-1h1v1z",
    fill: "#83807e"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1z",
    fill: "#85807c"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1z",
    fill: "#6a655e",
    fillOpacity: 0.89
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M79 76h-1v-1h1z",
    fill: "#ada8a2",
    fillOpacity: 0.184
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76h-1v-1h1z",
    fill: "#ada8a2",
    fillOpacity: 0.173
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1z",
    fill: "#a7a5a1",
    fillOpacity: 0.784
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#a2a19d"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1z",
    fill: "#92918c"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#8e8b85"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#87847e"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1z",
    fill: "#86837f"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76v1h-1v-1z",
    fill: "#817e7a"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76v1h-1v-1z",
    fill: "#7f7b77"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1z",
    fill: "#898580"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M69 77h-1v-1h1z",
    fill: "#7b7773"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77v-1h1v1z",
    fill: "#8a8a88"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1z",
    fill: "#706d65",
    fillOpacity: 0.894
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h1z",
    fill: "#a8a8a2",
    fillOpacity: 0.173
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76v1h-1v-1z",
    fill: "#b1aba0",
    fillOpacity: 0.18
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77h1v1h-1z",
    fill: "#a09e9a",
    fillOpacity: 0.749
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M43 77h1v1h-1z",
    fill: "#969590"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v-1h1v1z",
    fill: "#8a8783"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1z",
    fill: "#93908b"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h-1v-1h1z",
    fill: "#86827b"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78v-1h1v1z",
    fill: "#8c8882"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78v-1h1v1z",
    fill: "#777470"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78v-1h1v1z",
    fill: "#76726f"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78h-1v-1h1z",
    fill: "#858381"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M77 77h1v1h-1z",
    fill: "#67655d",
    fillOpacity: 0.906
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77v1h-1v-1z",
    fill: "#a0a09a",
    fillOpacity: 0.169
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h1v1h-1z",
    fill: "#b5b5a7",
    fillOpacity: 0.149
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78v1h-1v-1z",
    fill: "#9d9993",
    fillOpacity: 0.698
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78h1v1h-1z",
    fill: "#95928d"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v1h-1v-1z",
    fill: "#908f8b"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1z",
    fill: "#8d8982"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M50 79h-1v-1h1z",
    fill: "#8b887f"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M51 79h-1v-1h1z",
    fill: "#888482"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M52 79h-1v-1h1z",
    fill: "#868282"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79h-1v-1h1z",
    fill: "#83807c"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-1h1v1z",
    fill: "#8d8a85"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h-1v-1h1z",
    fill: "#8a867e"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h1v1h-1z",
    fill: "#8f897f"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h1v1h-1z",
    fill: "#908982"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v1h-1z",
    fill: "#878482"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79h-1v-1h1z",
    fill: "#797874"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79h-1v-1h1z",
    fill: "#7d7b78"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78h1v1h-1z",
    fill: "#7b7779"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1z",
    fill: "#6c6861",
    fillOpacity: 0.925
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79h-1v-1h1z",
    fill: "#9c9c96",
    fillOpacity: 0.153
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78v1h-1v-1z",
    fill: "#b9b9aa",
    fillOpacity: 0.129
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-1v-1z",
    fill: "#9a938d",
    fillOpacity: 0.678
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M43 80v-1h1v1z",
    fill: "#9b9590"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79v1h-1v-1z",
    fill: "#928f8a"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M47 79h1v1h-1z",
    fill: "#888381"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M49 79v1h-1v-1z",
    fill: "#87817c"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M49 80v-1h1v1z",
    fill: "#8b8881"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-1v-1h1z",
    fill: "#8f8c88"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1z",
    fill: "#928f89"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1z",
    fill: "#8c8880"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79v1h-1v-1z",
    fill: "#88837c"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v-1h1v1z",
    fill: "#8b8986"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h-1v-1h1z",
    fill: "#7e7b75"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79v1h-1v-1z",
    fill: "#7d7b79"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M75 79h1v1h-1z",
    fill: "#7b7776"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80v-1h1v1z",
    fill: "#716f64",
    fillOpacity: 0.922
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1z",
    fill: "#afafa7",
    fillOpacity: 0.114
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v-1h1v1z",
    fill: "#b4b4aa",
    fillOpacity: 0.2
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81h-1v-1h1z",
    fill: "#9d9892",
    fillOpacity: 0.655
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81v-1h1v1z",
    fill: "#97928c"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M45 80v1h-1v-1z",
    fill: "#92908b"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M49 81h-1v-1h1z",
    fill: "#87827f"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81h-1v-1h1z",
    fill: "#7d7977"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-1v-1h1z",
    fill: "#797573"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#94918c"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#8c8781"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#8a857f"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80v1h-1v-1z",
    fill: "#81817f"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80h1v1h-1z",
    fill: "#878582"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h-1v-1h1z",
    fill: "#86817e"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1z",
    fill: "#8c8885"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M69 81h-1v-1h1z",
    fill: "#8c8886"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h1v1h-1z",
    fill: "#8c8783"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h1v1h-1z",
    fill: "#87837d"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M72 80h1v1h-1z",
    fill: "#83817e"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#7f7d7a"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80h1v1h-1z",
    fill: "#7a7673"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#79766c",
    fillOpacity: 0.922
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M79 81v-1h1v1z",
    fill: "#b3b3ac",
    fillOpacity: 0.145
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#bbbbb5",
    fillOpacity: 0.149
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81h-1v-1h1z",
    fill: "#ff0",
    fillOpacity: 0.004
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1z",
    fill: "#9d9995",
    fillOpacity: 0.643
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1z",
    fill: "#93908c"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#8e8a88"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M48 81h1v1h-1z",
    fill: "#888280"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M51 82v-1h1v1z",
    fill: "#7c7975"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81v1h-1v-1z",
    fill: "#7f7b79"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-1v-1z",
    fill: "#7a7674"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1z",
    fill: "#83827e"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#797774"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81v1h-1v-1z",
    fill: "#8e8b86"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1z",
    fill: "#7b7973"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v1h-1v-1z",
    fill: "#78756d"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82v-1h1v1z",
    fill: "#807d75"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M77 81v1h-1v-1z",
    fill: "#88857d"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M78 81v1h-1v-1z",
    fill: "#737069",
    fillOpacity: 0.918
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#a69c93",
    fillOpacity: 0.102
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h-1v-1h1z",
    fill: "#ccccb2",
    fillOpacity: 0.039
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M81 81h1v1h-1z",
    fill: "#c2bbb5",
    fillOpacity: 0.149
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M82 82v-1h1v1z",
    fill: "#bdbdb9",
    fillOpacity: 0.259
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h-1v-1h1z",
    fill: "#b8b8b8",
    fillOpacity: 0.157
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82h1v1h-1z",
    fill: "#aaa7a5",
    fillOpacity: 0.639
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1z",
    fill: "#a09c99"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M48 83h-1v-1h1z",
    fill: "#8d8886"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#878580"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M52 82v1h-1v-1z",
    fill: "#84827f"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82h1v1h-1z",
    fill: "#787473"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h1v1h-1z",
    fill: "#918e8a"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#86847f"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#84837e"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83h-1v-1h1z",
    fill: "#878483"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h1v1h-1z",
    fill: "#928f88"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83v-1h1v1z",
    fill: "#817e77"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M70 83v-1h1v1z",
    fill: "#84817c"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1z",
    fill: "#7e7b76"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82h1v1h-1z",
    fill: "#86827c"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1z",
    fill: "#716f66",
    fillOpacity: 0.914
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82v1h-1v-1z",
    fill: "#adada3",
    fillOpacity: 0.098
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83h1v1h-1z",
    fill: "#a3a09e",
    fillOpacity: 0.592
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M47 84v-1h1v1z",
    fill: "#898581"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83h1v1h-1z",
    fill: "#838281"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M51 83h1v1h-1z",
    fill: "#817f7b"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83h1v1h-1z",
    fill: "#88847d"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1z",
    fill: "#716e6b"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84v-1h1v1z",
    fill: "#8d8987"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83v1h-1v-1z",
    fill: "#81807b"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83v1h-1v-1z",
    fill: "#878682"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1z",
    fill: "#7c7b7a"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#8a887e"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M69 84h-1v-1h1z",
    fill: "#8b897d"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M71 83v1h-1v-1z",
    fill: "#838078"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84v-1h1v1z",
    fill: "#84817b"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#6d6961",
    fillOpacity: 0.91
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84v1h-1v-1z",
    fill: "#999593",
    fillOpacity: 0.51
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85h-1v-1h1z",
    fill: "#938e8b"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85h-1v-1h1z",
    fill: "#898583"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v1h-1v-1z",
    fill: "#8f8c86"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85v-1h1v1z",
    fill: "#918d8b"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85h-1v-1h1z",
    fill: "#848181"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M51 84h1v1h-1z",
    fill: "#868480"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M53 85h-1v-1h1z",
    fill: "#908d84"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M61 85h-1v-1h1z",
    fill: "#858482"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v-1h1v1z",
    fill: "#8e8b82"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84h1v1h-1z",
    fill: "#89867d"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v-1h1v1z",
    fill: "#88857c"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M71 85h-1v-1h1z",
    fill: "#8c8980"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84h1v1h-1z",
    fill: "#87847d"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M72 85v-1h1v1z",
    fill: "#787472"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84h1v1h-1z",
    fill: "#7a7774"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M75 84v1h-1v-1z",
    fill: "#7e7d78"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v1h-1v-1z",
    fill: "#7f7a75"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v-1h1v1z",
    fill: "#807c74",
    fillOpacity: 0.918
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84v1h-1v-1z",
    fill: "#c4c4b0",
    fillOpacity: 0.102
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M82 85v-1h1v1z",
    fill: "#ccccc1",
    fillOpacity: 0.098
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M43 86h-1v-1h1z",
    fill: "#adaaaa",
    fillOpacity: 0.518
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h-1v-1h1z",
    fill: "#8b8782"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-1h1z",
    fill: "#85827c"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86v-1h1v1z",
    fill: "#8a8884"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86h-1v-1h1z",
    fill: "#8a8780"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#848282"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M58 85h1v1h-1z",
    fill: "#898788"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M59 86v-1h1v1z",
    fill: "#8c8a8a"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85h1v1h-1z",
    fill: "#807e7c"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v1h-1v-1z",
    fill: "#83827f"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85h1v1h-1z",
    fill: "#84817a"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M70 85h1v1h-1z",
    fill: "#85827a"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v-1h1v1z",
    fill: "#7b7872"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M73 85v1h-1v-1z",
    fill: "#726f69"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v-1h1v1z",
    fill: "#7c7a75"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v1h-1v-1z",
    fill: "#817c78"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M78 86h-1v-1h1z",
    fill: "#7d766e",
    fillOpacity: 0.937
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v1h-1v-1z",
    fill: "#afa79e",
    fillOpacity: 0.114
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85h1v1h-1z",
    fill: "#bdbdb6",
    fillOpacity: 0.29
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M81 86v-1h1v1z",
    fill: "#c3c1b9",
    fillOpacity: 0.502
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M83 86h-1v-1h1z",
    fill: "#c5c3bb",
    fillOpacity: 0.471
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M83 85h1v1h-1z",
    fill: "#c4c4bc",
    fillOpacity: 0.514
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85h1v1h-1z",
    fill: "#c8c8be",
    fillOpacity: 0.514
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v-1h1v1z",
    fill: "#ccc9c1",
    fillOpacity: 0.278
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#bebdba",
    fillOpacity: 0.655
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M55 86v1h-1v-1z",
    fill: "#8b8a86"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86h1v1h-1z",
    fill: "#878685"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87v-1h1v1z",
    fill: "#858382"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v1h-1v-1z",
    fill: "#7d7a74"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M72 86v1h-1v-1z",
    fill: "#8f8a82"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v1h-1v-1z",
    fill: "#848079"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87h-1v-1h1z",
    fill: "#82807b"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M77 86h1v1h-1z",
    fill: "#6c6862",
    fillOpacity: 0.945
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M79 87h-1v-1h1z",
    fill: "#afaba2",
    fillOpacity: 0.227
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M79 86h1v1h-1z",
    fill: "#bfbcb7",
    fillOpacity: 0.376
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M80 86h1v1h-1z",
    fill: "#b6b6af",
    fillOpacity: 0.263
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v1h-1v-1z",
    fill: "#cacac1",
    fillOpacity: 0.114
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86h1v1h-1z",
    fill: "#c9c9c2",
    fillOpacity: 0.431
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87h-1v-1h1z",
    fill: "#cacac1",
    fillOpacity: 0.549
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87v-1h1v1z",
    fill: "#ccccbf",
    fillOpacity: 0.078
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M97 86h1v1h-1z",
    fill: "#c9bbbb",
    fillOpacity: 0.075
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M98 87v-1h1v1z",
    fill: "#cdc7c7",
    fillOpacity: 0.18
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M99 87v-1h1v1z",
    fill: "#c8c4c0",
    fillOpacity: 0.239
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M101 87h-1v-1h1z",
    fill: "#cdcdc9",
    fillOpacity: 0.204
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v1h-1v-1z",
    fill: "#bfbebb",
    fillOpacity: 0.847
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v1h-1v-1z",
    fill: "#a39f9c"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88h-1v-1h1z",
    fill: "#8c8c88"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87h1v1h-1z",
    fill: "#84817f"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M64 88v-1h1v1z",
    fill: "#817c79"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v-1h1v1z",
    fill: "#7a7775"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87h1v1h-1z",
    fill: "#7a7875"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87h1v1h-1z",
    fill: "#7e7975"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M78 88h-1v-1h1z",
    fill: "#68635f",
    fillOpacity: 0.996
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h-1v-1h1z",
    fill: "#aeaaa4",
    fillOpacity: 0.682
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88v-1h1v1z",
    fill: "#c1c1b8",
    fillOpacity: 0.114
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88v-1h1v1z",
    fill: "#c2c2b8",
    fillOpacity: 0.298
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87h1v1h-1z",
    fill: "#c2c2bb",
    fillOpacity: 0.608
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87v1h-1v-1z",
    fill: "#bcbcb8",
    fillOpacity: 0.212
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87v1h-1v-1z",
    fill: "#d0d0cc",
    fillOpacity: 0.235
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87h1v1h-1z",
    fill: "#cdcac7",
    fillOpacity: 0.341
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M98 87v1h-1v-1z",
    fill: "#cdcac8",
    fillOpacity: 0.365
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M98 87h1v1h-1z",
    fill: "#ccc9c6",
    fillOpacity: 0.353
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M99 87h1v1h-1z",
    fill: "#c8c8c4",
    fillOpacity: 0.31
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M101 87v1h-1v-1z",
    fill: "#cacac4",
    fillOpacity: 0.325
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M102 88h-1v-1h1z",
    fill: "#d1cfcc",
    fillOpacity: 0.396
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M102 87h1v1h-1z",
    fill: "#d6d6d1",
    fillOpacity: 0.392
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89h-1v-1h1z",
    fill: "#bdbdbd",
    fillOpacity: 0.169
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#c0bebc",
    fillOpacity: 0.965
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M45 89h-1v-1h1z",
    fill: "#aaa6a3"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v-1h1v1z",
    fill: "#7c7a77"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M63 89h-1v-1h1z",
    fill: "#777472"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M63 88h1v1h-1z",
    fill: "#7b7876"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v1h-1v-1z",
    fill: "#797673"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M66 88v1h-1v-1z",
    fill: "#767471"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M71 88h1v1h-1z",
    fill: "#7c7976"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M73 88v1h-1v-1z",
    fill: "#827e7c"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88h1v1h-1z",
    fill: "#8f8a85"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88v1h-1v-1z",
    fill: "#857f7b"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88h1v1h-1z",
    fill: "#827d79"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v-1h1v1z",
    fill: "#68635f"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M78 89v-1h1v1z",
    fill: "#96908b",
    fillOpacity: 0.373
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M89 88h1v1h-1z",
    fill: "#b8b8b4",
    fillOpacity: 0.227
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M91 89h-1v-1h1z",
    fill: "#bfaaaa",
    fillOpacity: 0.047
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89h-1v-1h1z",
    fill: "#d2cfcc",
    fillOpacity: 0.294
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89v-1h1v1z",
    fill: "#d1cfca",
    fillOpacity: 0.42
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M95 88h1v1h-1z",
    fill: "#cdcdc8",
    fillOpacity: 0.2
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M97 88v1h-1v-1z",
    fill: "#d0d0b9",
    fillOpacity: 0.043
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M103 89h-1v-1h1z",
    fill: "#d3d3ce",
    fillOpacity: 0.227
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M104 88v1h-1v-1z",
    fill: "#d5d3d0",
    fillOpacity: 0.455
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h1v1h-1z",
    fill: "#bdbdba",
    fillOpacity: 0.29
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1z",
    fill: "#bfbbb8"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h-1v-1h1z",
    fill: "#b4b0ad"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M46 89v1h-1v-1z",
    fill: "#989491"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v1h-1v-1z",
    fill: "#7f7a77"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h1z",
    fill: "#7b7a7a"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v-1h1v1z",
    fill: "#7c7b7b"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89v1h-1v-1z",
    fill: "#7e7d7a"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M71 89h1v1h-1z",
    fill: "#7e7b7c"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M73 89h1v1h-1z",
    fill: "#847f7a"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M74 90v-1h1v1z",
    fill: "#9a948b"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M76 89v1h-1v-1z",
    fill: "#9d9790"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v1h-1v-1z",
    fill: "#88817b"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M77 90v-1h1v1z",
    fill: "#67605b"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M85 89h1v1h-1z",
    fill: "#c2c2c2",
    fillOpacity: 0.082
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M86 90v-1h1v1z",
    fill: "#c4c4c0",
    fillOpacity: 0.255
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M89 90v-1h1v1z",
    fill: "#bfbfb4",
    fillOpacity: 0.094
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M92 89v1h-1v-1z",
    fill: "#c6c6c0",
    fillOpacity: 0.176
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M93 89v1h-1v-1z",
    fill: "#d1ccc8",
    fillOpacity: 0.239
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90v-1h1v1z",
    fill: "#cdcdc7",
    fillOpacity: 0.18
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M103 90v-1h1v1z",
    fill: "#ccc",
    fillOpacity: 0.216
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M105 90h-1v-1h1z",
    fill: "#d2d2cf",
    fillOpacity: 0.357
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#c3c1bd"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90h1v1h-1z",
    fill: "#b8b3b0"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M50 91v-1h1v1z",
    fill: "#7b7774"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v1z",
    fill: "#797572"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#777671"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91h-1v-1h1z",
    fill: "#706f6a"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#7b7d78"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91h-1v-1h1z",
    fill: "#7b7b7a"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v-1h1v1z",
    fill: "#7b797a"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M59 90h1v1h-1z",
    fill: "#737271"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M62 90v1h-1v-1z",
    fill: "#777573"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v1h-1v-1z",
    fill: "#7e7c7c"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91h-1v-1h1z",
    fill: "#888682"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v1h-1v-1z",
    fill: "#83807f"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h1v1h-1z",
    fill: "#807d7c"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v-1h1v1z",
    fill: "#807e7d"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91h-1v-1h1z",
    fill: "#908c85"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91h-1v-1h1z",
    fill: "#847f78"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M78 90v1h-1v-1z",
    fill: "#645f58"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91v-1h1v1z",
    fill: "#c5c8c1",
    fillOpacity: 0.294
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M87 91h-1v-1h1z",
    fill: "#c1c8c1",
    fillOpacity: 0.129
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M104 91v-1h1v1z",
    fill: "#cecec9",
    fillOpacity: 0.373
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M105 91v-1h1v1z",
    fill: "#d4d4c9",
    fillOpacity: 0.094
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1z",
    fill: "#b4b2af",
    fillOpacity: 0.365
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#bdbbb7"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92h-1v-1h1z",
    fill: "#adaaa7"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92v-1h1v1z",
    fill: "#9c9895"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1z",
    fill: "#878480"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91h1v1h-1z",
    fill: "#767470"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#777672"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#6e6c67"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M55 91v1h-1v-1z",
    fill: "#7e7c77"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-1z",
    fill: "#757470"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92v-1h1v1z",
    fill: "#7f807b"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v-1h1v1z",
    fill: "#767571"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92h-1v-1h1z",
    fill: "#797976"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92h-1v-1h1z",
    fill: "#797672"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h-1v-1h1z",
    fill: "#7d7877"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M72 92v-1h1v1z",
    fill: "#898682"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M77 92h-1v-1h1z",
    fill: "#a6a19e"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h-1v-1h1z",
    fill: "#a19c97"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M78 91h1v1h-1z",
    fill: "#807e75",
    fillOpacity: 0.357
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M85 92h-1v-1h1z",
    fill: "#c9c9c0",
    fillOpacity: 0.224
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h1v1h-1z",
    fill: "#c5c5c1",
    fillOpacity: 0.227
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M95 91h1v1h-1z",
    fill: "#d5d2cf",
    fillOpacity: 0.314
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v-1h1v1z",
    fill: "#d0cfca",
    fillOpacity: 0.671
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M98 92h-1v-1h1z",
    fill: "#aaa",
    fillOpacity: 0.047
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M104 92v-1h1v1z",
    fill: "#cecec6",
    fillOpacity: 0.247
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M106 92h-1v-1h1z",
    fill: "#d6d6cd",
    fillOpacity: 0.345
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#b2b2a5",
    fillOpacity: 0.078
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#a7a5a1",
    fillOpacity: 0.459
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93v-1h1v1z",
    fill: "#999794",
    fillOpacity: 0.608
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92v1h-1v-1z",
    fill: "#858480",
    fillOpacity: 0.741
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#817e7b",
    fillOpacity: 0.851
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#777472",
    fillOpacity: 0.949
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93h-1v-1h1z",
    fill: "#787876"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1z",
    fill: "#777570"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#73736e"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M52 92h1v1h-1z",
    fill: "#787875"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#767674"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M56 93h-1v-1h1z",
    fill: "#737270"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93h-1v-1h1z",
    fill: "#73726e"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92h1v1h-1z",
    fill: "#71706c"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M59 92h1v1h-1z",
    fill: "#787773"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h-1v-1h1z",
    fill: "#757570"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93v-1h1v1z",
    fill: "#6e6f6b"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M64 92v1h-1v-1z",
    fill: "#6c6b69"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M66 92h1v1h-1z",
    fill: "#757371"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M71 92h1v1h-1z",
    fill: "#7c7b76"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92h1v1h-1z",
    fill: "#878481"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93v-1h1v1z",
    fill: "#8b8685"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93v-1h1v1z",
    fill: "#a29d9b"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93h-1v-1h1z",
    fill: "#a49f9a"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h1v1h-1z",
    fill: "#8e8a83",
    fillOpacity: 0.784
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92h1v1h-1z",
    fill: "#c5c2ba",
    fillOpacity: 0.365
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92v1h-1v-1z",
    fill: "#c5bfb8",
    fillOpacity: 0.157
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92h1v1h-1z",
    fill: "#bbbbb2",
    fillOpacity: 0.118
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93v-1h1v1z",
    fill: "#c0c0b7",
    fillOpacity: 0.239
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92v1h-1v-1z",
    fill: "#c1c1bc",
    fillOpacity: 0.388
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92h1v1h-1z",
    fill: "#c2c2b9",
    fillOpacity: 0.231
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M89 93h-1v-1h1z",
    fill: "#dadad5",
    fillOpacity: 0.192
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M89 92h1v1h-1z",
    fill: "#dfdfda",
    fillOpacity: 0.439
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M90 92h1v1h-1z",
    fill: "#e1e1de",
    fillOpacity: 0.706
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93v-1h1v1z",
    fill: "#e1e0df",
    fillOpacity: 0.859
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M93 93h-1v-1h1z",
    fill: "#e2e2df",
    fillOpacity: 0.863
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M93 92h1v1h-1z",
    fill: "#e4e3e1",
    fillOpacity: 0.835
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92h1v1h-1z",
    fill: "#e3e2e0",
    fillOpacity: 0.843
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v1h-1v-1z",
    fill: "#e3e1dd",
    fillOpacity: 0.976
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93h-1v-1h1z",
    fill: "#dbd9d5"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93v-1h1v1z",
    fill: "#d6d4d0",
    fillOpacity: 0.514
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M98 92h1v1h-1z",
    fill: "#dad1d1",
    fillOpacity: 0.11
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M104 92h1v1h-1z",
    fill: "#c1c1c1",
    fillOpacity: 0.098
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M106 93h-1v-1h1z",
    fill: "#d2d0cb",
    fillOpacity: 0.561
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h-1v-1h1z",
    fill: "#4e4e4e",
    fillOpacity: 0.051
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-1v-1z",
    fill: "#595952",
    fillOpacity: 0.145
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94h-1v-1h1z",
    fill: "#565652",
    fillOpacity: 0.255
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93v1h-1v-1z",
    fill: "#61615f",
    fillOpacity: 0.4
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#676766",
    fillOpacity: 0.529
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93v1h-1v-1z",
    fill: "#6b6966",
    fillOpacity: 0.671
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93v1h-1v-1z",
    fill: "#6e6e6a",
    fillOpacity: 0.804
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h1v1h-1z",
    fill: "#6e6f6d",
    fillOpacity: 0.902
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94h-1v-1h1z",
    fill: "#767576",
    fillOpacity: 0.965
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#807d7f"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h-1v-1h1z",
    fill: "#767474"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94v-1h1v1z",
    fill: "#6f6f6d"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M59 93v1h-1v-1z",
    fill: "#747371"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93h1v1h-1z",
    fill: "#787676"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M61 93h1v1h-1z",
    fill: "#7c7978"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h1v1h-1z",
    fill: "#716f6e"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M64 93v1h-1v-1z",
    fill: "#6a696a"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v1h-1v-1z",
    fill: "#767373"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M65 94v-1h1v1z",
    fill: "#767372"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94v-1h1v1z",
    fill: "#6e6d6b"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M71 93v1h-1v-1z",
    fill: "#84837f"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94h-1v-1h1z",
    fill: "#83807a"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M75 94h-1v-1h1z",
    fill: "#8f8b87"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93h1v1h-1z",
    fill: "#a39e99"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93v1h-1v-1z",
    fill: "#a09b95"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M78 94v-1h1v1z",
    fill: "#89847e",
    fillOpacity: 0.529
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M80 93v1h-1v-1z",
    fill: "#b9b4ae",
    fillOpacity: 0.361
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94v-1h1v1z",
    fill: "#bbb6b0",
    fillOpacity: 0.443
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94v-1h1v1z",
    fill: "#bbb7b0",
    fillOpacity: 0.447
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93h1v1h-1z",
    fill: "#bab7b1",
    fillOpacity: 0.349
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M83 94v-1h1v1z",
    fill: "#b4acac",
    fillOpacity: 0.133
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M84 93h1v1h-1z",
    fill: "#c6c6bc",
    fillOpacity: 0.106
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94v-1h1v1z",
    fill: "#d7d7d3",
    fillOpacity: 0.325
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M86 93h1v1h-1z",
    fill: "#dbddd7",
    fillOpacity: 0.561
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M88 93v1h-1v-1z",
    fill: "#deded9",
    fillOpacity: 0.82
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M89 94h-1v-1h1z",
    fill: "#e2e1dd",
    fillOpacity: 0.973
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M90 93v1h-1v-1z",
    fill: "#eae9e4"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M91 94h-1v-1h1z",
    fill: "#e9e8e5"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M94 94h-1v-1h1z",
    fill: "#eae9e7"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M96 94h-1v-1h1z",
    fill: "#e9e6e2"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93v1h-1v-1z",
    fill: "#e0dcd8"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93h1v1h-1z",
    fill: "#e4e0dd"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M99 94h-1v-1h1z",
    fill: "#e6e4e3",
    fillOpacity: 0.906
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M99 94v-1h1v1z",
    fill: "#e2e2e1",
    fillOpacity: 0.569
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M100 93h1v1h-1z",
    fill: "#ddddd9",
    fillOpacity: 0.212
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M105 93h1v1h-1z",
    fill: "#ccccc6",
    fillOpacity: 0.588
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M106 94v-1h1v1z",
    fill: "#d0d0c8",
    fillOpacity: 0.129
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1z",
    fillOpacity: 0.024
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M53 94v1h-1v-1z",
    fill: "#424242",
    fillOpacity: 0.09
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#5a5555",
    fillOpacity: 0.176
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94v1h-1v-1z",
    fill: "#6d6969",
    fillOpacity: 0.302
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h1v1h-1z",
    fill: "#676464",
    fillOpacity: 0.349
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h1v1h-1z",
    fill: "#666363",
    fillOpacity: 0.373
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94v1h-1v-1z",
    fill: "#797777",
    fillOpacity: 0.592
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h-1v-1h1z",
    fill: "#7e7d7d",
    fillOpacity: 0.839
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94v1h-1v-1z",
    fill: "#777678",
    fillOpacity: 0.949
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95v-1h1v1z",
    fill: "#767476",
    fillOpacity: 0.996
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M61 94h1v1h-1z",
    fill: "#7e7c7f"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M63 94v1h-1v-1z",
    fill: "#787777"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M63 95v-1h1v1z",
    fill: "#777774"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M64 94h1v1h-1z",
    fill: "#737172"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M66 94v1h-1v-1z",
    fill: "#747274"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M67 95v-1h1v1z",
    fill: "#73726f"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h1v1h-1z",
    fill: "#696864"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M71 94h1v1h-1z",
    fill: "#7b7875"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M72 94h1v1h-1z",
    fill: "#7b7873"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95v-1h1v1z",
    fill: "#a4a098"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M77 95v-1h1v1z",
    fill: "#89857b"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M79 94v1h-1v-1z",
    fill: "#727068",
    fillOpacity: 0.42
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94h1v1h-1z",
    fill: "#cecec7",
    fillOpacity: 0.145
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95h-1v-1h1z",
    fill: "#d6d4d1",
    fillOpacity: 0.42
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M84 94v1h-1v-1z",
    fill: "#dad8d6",
    fillOpacity: 0.722
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M84 95v-1h1v1z",
    fill: "#dfdbda",
    fillOpacity: 0.922
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94h1v1h-1z",
    fill: "#e5e2e0"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M87 94v1h-1v-1z",
    fill: "#eae7e5"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95v-1h1v1z",
    fill: "#e7e4e2"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M89 94v1h-1v-1z",
    fill: "#e4e1df"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95v-1h1v1z",
    fill: "#e3e0de"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M94 95v-1h1v1z",
    fill: "#e4e2e2"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M96 94v1h-1v-1z",
    fill: "#e6e4e2"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M98 94v1h-1v-1z",
    fill: "#d9d6d0"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M99 95h-1v-1h1z",
    fill: "#ebe7e4"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M99 94h1v1h-1z",
    fill: "#efece9"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M101 95h-1v-1h1z",
    fill: "#e8e4e1",
    fillOpacity: 0.973
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M101 95v-1h1v1z",
    fill: "#e7e3e0",
    fillOpacity: 0.765
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M103 94v1h-1v-1z",
    fill: "#e2e0dd",
    fillOpacity: 0.392
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M106 95h-1v-1h1z",
    fill: "#c9c7c0",
    fillOpacity: 0.467
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M107 95h-1v-1h1z",
    fill: "#ccc8c4",
    fillOpacity: 0.255
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h1v1h-1z",
    fill: "#5c5c5c",
    fillOpacity: 0.043
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h1v1h-1z",
    fill: "#716a71",
    fillOpacity: 0.141
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h-1v-1h1z",
    fill: "#716d71",
    fillOpacity: 0.247
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95v1h-1v-1z",
    fill: "#6f6c72",
    fillOpacity: 0.341
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95h1v1h-1z",
    fill: "#6d6d6d",
    fillOpacity: 0.475
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h-1v-1h1z",
    fill: "#6d6d6a",
    fillOpacity: 0.631
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96h-1v-1h1z",
    fill: "#6e6c6c",
    fillOpacity: 0.745
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h-1v-1h1z",
    fill: "#706f70",
    fillOpacity: 0.878
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96v-1h1v1z",
    fill: "#747370",
    fillOpacity: 0.965
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M71 96v-1h1v1z",
    fill: "#787673"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h-1v-1h1z",
    fill: "#6f6c68"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M74 96h-1v-1h1z",
    fill: "#787572"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v-1h1v1z",
    fill: "#6e6a60",
    fillOpacity: 0.996
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96v-1h1v1z",
    fill: "#716f69",
    fillOpacity: 0.475
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96h-1v-1h1z",
    fill: "#e1dedb",
    fillOpacity: 0.31
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96v-1h1v1z",
    fill: "#dedbd6",
    fillOpacity: 0.71
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M81 95h1v1h-1z",
    fill: "#e0ded8",
    fillOpacity: 0.949
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M94 95h1v1h-1z",
    fill: "#e4e2e3"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M96 95h1v1h-1z",
    fill: "#e5e2df"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M98 96h-1v-1h1z",
    fill: "#d5d2cc"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M98 95h1v1h-1z",
    fill: "#dddad4"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M99 95h1v1h-1z",
    fill: "#e3dfdb"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M100 96v-1h1v1z",
    fill: "#e1deda"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M103 96h-1v-1h1z",
    fill: "#ede9e7"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M103 95h1v1h-1z",
    fill: "#e6e1e0",
    fillOpacity: 0.686
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M105 95v1h-1v-1z",
    fill: "#e1dedb",
    fillOpacity: 0.341
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M105 96v-1h1v1z",
    fill: "#c9c6c0",
    fillOpacity: 0.659
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M107 95v1h-1v-1z",
    fill: "#9f9f94",
    fillOpacity: 0.094
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M65 97v-1h1v1z",
    fill: "#5a5a5a",
    fillOpacity: 0.067
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#616161",
    fillOpacity: 0.165
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M67 96h1v1h-1z",
    fill: "#656561",
    fillOpacity: 0.286
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97h-1v-1h1z",
    fill: "#727070",
    fillOpacity: 0.435
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M70 96v1h-1v-1z",
    fill: "#757373",
    fillOpacity: 0.604
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97v-1h1v1z",
    fill: "#757474",
    fillOpacity: 0.722
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96v1h-1v-1z",
    fill: "#747372",
    fillOpacity: 0.867
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96h1v1h-1z",
    fill: "#7b7a78",
    fillOpacity: 0.973
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h1v1h-1z",
    fill: "#868581"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v1h-1v-1z",
    fill: "#95908a"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M77 97v-1h1v1z",
    fill: "#9f9b94",
    fillOpacity: 0.992
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96h1v1h-1z",
    fill: "#d4d1cd",
    fillOpacity: 0.925
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v-1h1v1z",
    fill: "#e6e2de"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M80 97v-1h1v1z",
    fill: "#ece9e4"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M81 96h1v1h-1z",
    fill: "#e8e4e1"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97v-1h1v1z",
    fill: "#e4e3e2"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M95 96h1v1h-1z",
    fill: "#e3e2df"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M97 96h1v1h-1z",
    fill: "#dfdcd7"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M99 96v1h-1v-1z",
    fill: "#e0ddd8"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M101 97h-1v-1h1z",
    fill: "#e3e0db"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M101 97v-1h1v1z",
    fill: "#e5e2dd"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M103 96h1v1h-1z",
    fill: "#ede9e6"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M104 96h1v1h-1z",
    fill: "#ece8e5"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M106 97h-1v-1h1z",
    fill: "#e1ddd9",
    fillOpacity: 0.937
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M106 97v-1h1v1z",
    fill: "#dfddd8",
    fillOpacity: 0.447
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M107 97v-1h1v1z",
    fill: "#d8d0d0",
    fillOpacity: 0.129
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M71 97h1v1h-1z",
    fill: "#666",
    fillOpacity: 0.059
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98h-1v-1h1z",
    fill: "#717171",
    fillOpacity: 0.176
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v1h-1v-1z",
    fill: "#75726f",
    fillOpacity: 0.314
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97h1v1h-1z",
    fill: "#918f89",
    fillOpacity: 0.647
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M76 97v1h-1v-1z",
    fill: "#bab6b1",
    fillOpacity: 0.992
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M76 98v-1h1v1z",
    fill: "#ded9d3"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M78 97v1h-1v-1z",
    fill: "#ebe6e1"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98v-1h1v1z",
    fill: "#e5e5e1"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M97 97v1h-1v-1z",
    fill: "#e7e4e1"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M108 97v1h-1v-1z",
    fill: "#e3e2e0",
    fillOpacity: 0.925
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M108 98v-1h1v1z",
    fill: "#e0dfdd",
    fillOpacity: 0.631
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M110 97v1h-1v-1z",
    fill: "#d7d7d3",
    fillOpacity: 0.251
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.055
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99h-1v-1h1z",
    fill: "#e4e2de",
    fillOpacity: 0.667
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99h-1v-1h1z",
    fill: "#e9e5e1",
    fillOpacity: 0.925
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99v-1h1v1z",
    fill: "#eae6e3"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M109 98v1h-1v-1z",
    fill: "#f3f0ef"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M109 99v-1h1v1z",
    fill: "#e0dfdd",
    fillOpacity: 0.961
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M110 98h1v1h-1z",
    fill: "#cfcfc7",
    fillOpacity: 0.125
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100h-1v-1h1z",
    fill: "#dedcd9",
    fillOpacity: 0.373
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99v1h-1v-1z",
    fill: "#f2f0ed"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M104 99h1v1h-1z",
    fill: "#e7e3e3"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M106 99h1v1h-1z",
    fill: "#efeae9"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M108 100h-1v-1h1z",
    fill: "#ece6e5"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M109 100h-1v-1h1z",
    fill: "#e6e1e0",
    fillOpacity: 0.929
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M110 100h-1v-1h1z",
    fill: "#e0dddb",
    fillOpacity: 0.651
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100v1h-1v-1z",
    fill: "#dfdfdd",
    fillOpacity: 0.471
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M73 101v-1h1v1z",
    fill: "#e9e7e6",
    fillOpacity: 0.949
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M76 101h-1v-1h1z",
    fill: "#ebe7e5"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M90 101v-1h1v1z",
    fill: "#e8e6e4"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M104 100h1v1h-1z",
    fill: "#e3dfde",
    fillOpacity: 0.988
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M106 101h-1v-1h1z",
    fill: "#e1dedc",
    fillOpacity: 0.851
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M107 100v1h-1v-1z",
    fill: "#ddd6d5",
    fillOpacity: 0.647
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M108 101h-1v-1h1z",
    fill: "#d6d0ce",
    fillOpacity: 0.369
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M108 101v-1h1v1z",
    fill: "#c7bfbf",
    fillOpacity: 0.125
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h-1v-1h1z",
    fill: "#d3d3d3",
    fillOpacity: 0.161
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M75 101v1h-1v-1z",
    fill: "#e1dddb",
    fillOpacity: 0.514
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M75 102v-1h1v1z",
    fill: "#e6e3e2",
    fillOpacity: 0.871
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M98 101h1v1h-1z",
    fill: "#eae6e5"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M102 102h-1v-1h1z",
    fill: "#e3dfde",
    fillOpacity: 0.922
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M103 102h-1v-1h1z",
    fill: "#ded9d7",
    fillOpacity: 0.729
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M103 101h1v1h-1z",
    fill: "#d6d2ce",
    fillOpacity: 0.475
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M105 102h-1v-1h1z",
    fill: "#c9c4c4",
    fillOpacity: 0.224
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M106 102h-1v-1h1z",
    fill: "#b09c9c",
    fillOpacity: 0.051
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M76 103h-1v-1h1z",
    fill: "#d0c5c5",
    fillOpacity: 0.086
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103h-1v-1h1z",
    fill: "#d9d5d5",
    fillOpacity: 0.431
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103h-1v-1h1z",
    fill: "#e1dedd",
    fillOpacity: 0.808
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103v-1h1v1z",
    fill: "#e6e4e3"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M79 102h1v1h-1z",
    fill: "#efedeb"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M90 102h1v1h-1z",
    fill: "#e9e6e4"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M91 102h1v1h-1z",
    fill: "#e8e5e4"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103h-1v-1h1z",
    fill: "#eee9e7"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103v-1h1v1z",
    fill: "#f1ece9"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M99 103h-1v-1h1z",
    fill: "#e4e0de",
    fillOpacity: 0.91
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M99 102h1v1h-1z",
    fill: "#dbd6d5",
    fillOpacity: 0.647
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M100 103v-1h1v1z",
    fill: "#cfccc9",
    fillOpacity: 0.357
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M102 102v1h-1v-1z",
    fill: "#c5bdbd",
    fillOpacity: 0.122
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104v-1h1v1z",
    fill: "#999",
    fillOpacity: 0.039
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M79 104h-1v-1h1z",
    fill: "#d1cece",
    fillOpacity: 0.31
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v1h-1v-1z",
    fill: "#dcdcd9",
    fillOpacity: 0.694
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M80 104v-1h1v1z",
    fill: "#e6e2e1",
    fillOpacity: 0.961
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M81 103h1v1h-1z",
    fill: "#f2edec"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M83 104h-1v-1h1z",
    fill: "#ece9e7"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M96 103v1h-1v-1z",
    fill: "#f0ecea"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103v1h-1v-1z",
    fill: "#e4e0dc",
    fillOpacity: 0.878
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M97 104v-1h1v1z",
    fill: "#dcd6d2",
    fillOpacity: 0.49
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M99 104h-1v-1h1z",
    fill: "#bdbdb4",
    fillOpacity: 0.122
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M81 104v1h-1v-1z",
    fill: "#cec8c8",
    fillOpacity: 0.184
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M82 104v1h-1v-1z",
    fill: "#dbd9d7",
    fillOpacity: 0.533
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105v-1h1v1z",
    fill: "#e4e3e0",
    fillOpacity: 0.863
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104v1h-1v-1z",
    fill: "#edeae8"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104v1h-1v-1z",
    fill: "#ebe6e5"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M93 104v1h-1v-1z",
    fill: "#efebe9"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M95 105h-1v-1h1z",
    fill: "#e3e0dd",
    fillOpacity: 0.847
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M96 104v1h-1v-1z",
    fill: "#d8d4d2",
    fillOpacity: 0.467
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M97 105h-1v-1h1z",
    fill: "#b1b1a6",
    fillOpacity: 0.09
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106v-1h1v1z",
    fill: "#dcd9d9",
    fillOpacity: 0.376
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105v1h-1v-1z",
    fill: "#e5e1df",
    fillOpacity: 0.737
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M86 106h-1v-1h1z",
    fill: "#e8e5e4",
    fillOpacity: 0.973
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M91 106h-1v-1h1z",
    fill: "#f0ebe8"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M92 105h1v1h-1z",
    fill: "#dfdcd8",
    fillOpacity: 0.8
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M94 106h-1v-1h1z",
    fill: "#d4d1cc",
    fillOpacity: 0.396
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M95 105v1h-1v-1z",
    fill: "#afafaf",
    fillOpacity: 0.063
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106h1v1h-1z",
    fill: "#ddddd8",
    fillOpacity: 0.208
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M87 106v1h-1v-1z",
    fill: "#e2e0de",
    fillOpacity: 0.455
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M87 107v-1h1v1z",
    fill: "#dcd8d8",
    fillOpacity: 0.467
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M89 106v1h-1v-1z",
    fill: "#dad6d4",
    fillOpacity: 0.467
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M90 106v1h-1v-1z",
    fill: "#d6d3d1",
    fillOpacity: 0.439
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M91 106v1h-1v-1z",
    fill: "#d6d1ce",
    fillOpacity: 0.416
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107h-1v-1h1z",
    fill: "#cdc9c6",
    fillOpacity: 0.282
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107v-1h1v1z",
    fill: "#737373",
    fillOpacity: 0.043
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeaBag);
export default __webpack_public_path__ + "static/media/tea-bag.3a69d791105ac345040af7afcd28d61f.svg";
export { ForwardRef as ReactComponent };